// generated with @7nohe/openapi-react-query-codegen@2.0.0-beta.3

import { type Options } from '@hey-api/client-fetch';
import { UseQueryResult } from '@tanstack/react-query';
import {
  abortAction,
  abortMediaLibraryUpload,
  abortWorkflow,
  abortWorkflowViaApi,
  activateInvitationCode,
  addNodesToCanvasPage,
  attachVideoEditProjectAssets,
  authorizeComposioConnection,
  autoNameCanvas,
  batchBindSocialAccountsToCategory,
  batchCreateDriveFiles,
  batchCreateProviderItems,
  batchCreateResource,
  batchCreateSocialAccounts,
  batchDeleteMediaLibraryEntries,
  batchUnbindSocialAccountsFromCategory,
  batchUpdateDocument,
  batchUpdateProviderItems,
  bindSocialAccountToCategory,
  cancelOneSocialAccountLoginBatch,
  cancelProductionStudioBatch,
  cancelSocialBrowserSession,
  cancelSocialBrowserSessionBatch,
  cancelSocialBrowserSessionBatchItem,
  checkSettingsField,
  checkSocialAccountInteractiveLogin,
  checkToolOauthStatus,
  checkVerification,
  claimVoucherInvitation,
  closeSocialAccountLoginBrowser,
  completeMediaLibraryUpload,
  completeSocialAccountInteractiveLogin,
  completeSocialBrowserSession,
  completeVideoManualEdit,
  confirmAllProductionStudioScripts,
  confirmProductionStudioScript,
  confirmVideoEditNarrative,
  continueSocialAccountLoginBatch,
  convert,
  copyProductionStudioBatch,
  createCanvas,
  createCanvasMaterialDownloadTask,
  createCanvasTemplate,
  createCanvasVersion,
  createCheckoutSession,
  createCliApiKey,
  createCodeArtifact,
  createCreditPackCheckoutSession,
  createDocument,
  createDriveFile,
  createLabelClass,
  createLabelInstance,
  createManagedModel,
  createMcpServer,
  createMediaLibraryDownloadTask,
  createMediaLibraryEntry,
  createPayOrder,
  createPilotSession,
  createPortalSession,
  createProductionStudioBatch,
  createProject,
  createPromptSkill,
  createProvider,
  createProviderItem,
  createResource,
  createResourceWithFile,
  createSchedule,
  createShare,
  createSkillInstance,
  createSkillTrigger,
  createSocialAccount,
  createSocialAccountAutoBindingBatch,
  createSocialAccountCategory,
  createSocialBrowserSession,
  createSocialBrowserSessionBatch,
  createToolset,
  createVerification,
  createVideoEditProject,
  createVoucherInvitation,
  createWorkflowApp,
  createWorkflowSkill,
  deleteCanvas,
  deleteCopilotSession,
  deleteDocument,
  deleteDriveFile,
  deleteLabelClass,
  deleteLabelInstance,
  deleteManagedModel,
  deleteMcpServer,
  deletePageNode,
  deleteProductionStudioBatch,
  deleteProductionStudioScript,
  deleteProject,
  deleteProjectItems,
  deletePromptSkill,
  deleteProvider,
  deleteProviderItem,
  deleteResource,
  deleteSchedule,
  deleteShare,
  deleteSkillInstance,
  deleteSkillTrigger,
  deleteSocialAccount,
  deleteSocialAccountCategory,
  deleteToolset,
  deleteWorkflowApp,
  deleteWorkflowSkill,
  downloadExportJobResult,
  duplicateCanvas,
  duplicateShare,
  emailLogin,
  emailSignup,
  ensureProductionStudioWorkspace,
  executeTool,
  executeWorkflowApp,
  exportCanvas,
  exportDocument,
  exportSocialBrowserState,
  exportToolsetDefinitions,
  extendSocialBrowserSession,
  extractVariables,
  generateAppTemplate,
  generateMedia,
  generateWorkflowViaCopilot,
  getActionResult,
  getActiveSocialBrowserSessionBatch,
  getAuthConfig,
  getAvailableTools,
  getAvailableVouchers,
  getCanvasData,
  getCanvasDetail,
  getCanvasMaterialAccessUrl,
  getCanvasMaterialDownloadTask,
  getCanvasState,
  getCanvasTransactions,
  getCodeArtifactDetail,
  getCollabToken,
  getComposioConnectionStatus,
  getCopilotSessionDetail,
  getCreditBalance,
  getCreditRecharge,
  getCreditUsage,
  getCreditUsageByCanvasId,
  getCreditUsageByExecutionId,
  getCreditUsageByResultId,
  getDocumentDetail,
  getExportJobStatus,
  getFormDefinition,
  getMediaLibraryDownloadTask,
  getMediaLibraryEntry,
  getMediaLibraryEntryAccessUrl,
  getMediaLibraryUploadStatus,
  getModelOptions,
  getOpenapiConfig,
  getPageByCanvasId,
  getPageDetail,
  getPayOrder,
  getPilotSessionDetail,
  getProductionStudioBatch,
  getProductionStudioOutputAccessUrl,
  getProductionStudioOutputStrategyArtifact,
  getProductionStudioWorkspace,
  getProjectDetail,
  getPromptSkillDetail,
  getPromptSuggestions,
  getRecordSnapshot,
  getResourceDetail,
  getScheduleDetail,
  getScheduleRecordDetail,
  getScheduleRecords,
  getSettings,
  getSocialAccount,
  getSocialAccountCategory,
  getSocialAccountLoginBatchStatus,
  getSocialAccountOverview,
  getSocialAccountWorkflows,
  getSocialBrowserSession,
  getSocialBrowserSessionBatch,
  getSocialPublishExecutorStatus,
  getSubscriptionPlans,
  getSubscriptionUsage,
  getTemplateGenerationStatus,
  getToolCallResult,
  getVideoEditAssetAccessUrl,
  getVideoEditProject,
  getVideoEditProjectSnapshot,
  getVideoEditVersion,
  getWorkflowAppDetail,
  getWorkflowDetail,
  getWorkflowDetailViaApi,
  getWorkflowOutput,
  getWorkflowPlanDetail,
  getWorkflowSkill,
  getWorkflowStatusViaApi,
  getWorkflowVariables,
  hasBeenInvited,
  hasFilledForm,
  importCanvas,
  importCanvasMaterialsFromLibrary,
  importCanvasMaterialsToLibrary,
  importProductionStudioClientPack,
  importProductionStudioScripts,
  importSocialBrowserState,
  importSocialBrowserStateFile,
  initializeMediaLibraryUpload,
  initializeWorkflow,
  invokeSkill,
  invokeWorkflowSkill,
  issueSocialBrowserStateExportTicket,
  issueSocialBrowserViewerTicket,
  listAllScheduleRecords,
  listCanvases,
  listCanvasMaterials,
  listCanvasTemplateCategories,
  listCanvasTemplates,
  listCategoriesBySocialAccount,
  listCliApiKeys,
  listCodeArtifacts,
  listCopilotSessions,
  listDocuments,
  listDriveFiles,
  listInvitationCodes,
  listLabelClasses,
  listLabelInstances,
  listManagedModels,
  listMcpServers,
  listMediaLibraryEntries,
  listModels,
  listPages,
  listPilotSessions,
  listProductionStudioClientPacks,
  listProjects,
  listPromptSkills,
  listProviderItemOptions,
  listProviderItems,
  listProviders,
  listResources,
  listSchedules,
  listShares,
  listSkillInstances,
  listSkills,
  listSkillTriggers,
  listSocialAccountCategories,
  listSocialAccounts,
  listSocialAccountsByCategory,
  listSocialPlatforms,
  listTools,
  listToolsetInventory,
  listToolsets,
  listUserTools,
  listUserVouchers,
  listWorkflowApps,
  listWorkflowExecutions,
  listWorkflowSkills,
  logout,
  manualBindSocialAccounts,
  materializeCopilotSession,
  moveSocialAccountsCategory,
  multiLingualWebSearch,
  openSocialBrowserViewerConnection,
  pauseProductionStudioBatch,
  pinSkillInstance,
  recognizeSocialAccounts,
  recoverPilotSession,
  refreshToken,
  regenerateProductionStudioScripts,
  regenerateVideoEditNarrative,
  reindexResource,
  resendVerification,
  restartWorkflowNode,
  retryScheduleRecord,
  reviewProductionStudioOutput,
  revokeCliApiKey,
  revokeComposioConnection,
  runWorkflowViaApi,
  saveOneSocialAccountLoginBatch,
  saveProductionStudioScript,
  saveSocialAccountLoginCookies,
  saveSocialBrowserState,
  saveVideoEditProjectSnapshot,
  scrape,
  search,
  searchMediaLibraryEntries,
  searchWorkflowsViaApi,
  serveStatic,
  setCanvasState,
  setSocialBrowserSessionAutomation,
  sharePage,
  signMediaLibraryUploadParts,
  startExportJob,
  startProductionStudioBatch,
  startSocialAccountInteractiveLogin,
  startSocialAccountLoginBatch,
  startSocialAccountReloginBatch,
  stopPublishTask,
  stopSocialAccountLoginBatch,
  streamInvokeSkill,
  submitForm,
  syncCanvasState,
  testProviderConnection,
  togglePromptSkill,
  triggerScheduleManually,
  unbindSocialAccountFromCategory,
  unpinSkillInstance,
  updateCanvas,
  updateCanvasTemplate,
  updateCliApiKey,
  updateCodeArtifact,
  updateDocument,
  updateDriveFile,
  updateLabelClass,
  updateLabelInstance,
  updateManagedModel,
  updateManagedModelStatus,
  updateMcpServer,
  updateMediaLibraryEntry,
  updateOpenapiConfig,
  updatePage,
  updatePilotSession,
  updateProductionStudioBatch,
  updateProductionStudioClientPackAsset,
  updateProductionStudioClientPackStatus,
  updateProject,
  updateProjectItems,
  updatePromptSkill,
  updateProvider,
  updateProviderItem,
  updateResource,
  updateSchedule,
  updateSettings,
  updateSkillInstance,
  updateSkillTrigger,
  updateSocialAccountCategory,
  updateSocialAccountCredential,
  updateSocialAccountProfile,
  updateSocialAccountRemark,
  updateSocialAccountStatus,
  updateToolset,
  updateWorkflowVariables,
  upload,
  uploadOpenapiFiles,
  validateMcpServer,
  validateVoucher,
  verifyVoucherInvitation,
} from '../requests/services.gen';
export type GetSocialAccountOverviewDefaultResponse = Awaited<
  ReturnType<typeof getSocialAccountOverview>
>['data'];
export type GetSocialAccountOverviewQueryResult<
  TData = GetSocialAccountOverviewDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSocialAccountOverviewKey = 'GetSocialAccountOverview';
export const UseGetSocialAccountOverviewKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetSocialAccountOverviewKey, ...(queryKey ?? [clientOptions])];
export type CheckSocialAccountInteractiveLoginDefaultResponse = Awaited<
  ReturnType<typeof checkSocialAccountInteractiveLogin>
>['data'];
export type CheckSocialAccountInteractiveLoginQueryResult<
  TData = CheckSocialAccountInteractiveLoginDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCheckSocialAccountInteractiveLoginKey = 'CheckSocialAccountInteractiveLogin';
export const UseCheckSocialAccountInteractiveLoginKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useCheckSocialAccountInteractiveLoginKey, ...(queryKey ?? [clientOptions])];
export type GetSocialAccountLoginBatchStatusDefaultResponse = Awaited<
  ReturnType<typeof getSocialAccountLoginBatchStatus>
>['data'];
export type GetSocialAccountLoginBatchStatusQueryResult<
  TData = GetSocialAccountLoginBatchStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSocialAccountLoginBatchStatusKey = 'GetSocialAccountLoginBatchStatus';
export const UseGetSocialAccountLoginBatchStatusKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetSocialAccountLoginBatchStatusKey, ...(queryKey ?? [clientOptions])];
export type ListWorkflowSkillsDefaultResponse = Awaited<
  ReturnType<typeof listWorkflowSkills>
>['data'];
export type ListWorkflowSkillsQueryResult<
  TData = ListWorkflowSkillsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListWorkflowSkillsKey = 'ListWorkflowSkills';
export const UseListWorkflowSkillsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListWorkflowSkillsKey, ...(queryKey ?? [clientOptions])];
export type GetWorkflowSkillDefaultResponse = Awaited<ReturnType<typeof getWorkflowSkill>>['data'];
export type GetWorkflowSkillQueryResult<
  TData = GetWorkflowSkillDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetWorkflowSkillKey = 'GetWorkflowSkill';
export const UseGetWorkflowSkillKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetWorkflowSkillKey, ...(queryKey ?? [clientOptions])];
export type ListSocialPlatformsDefaultResponse = Awaited<
  ReturnType<typeof listSocialPlatforms>
>['data'];
export type ListSocialPlatformsQueryResult<
  TData = ListSocialPlatformsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListSocialPlatformsKey = 'ListSocialPlatforms';
export const UseListSocialPlatformsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListSocialPlatformsKey, ...(queryKey ?? [clientOptions])];
export type ListSocialAccountsDefaultResponse = Awaited<
  ReturnType<typeof listSocialAccounts>
>['data'];
export type ListSocialAccountsQueryResult<
  TData = ListSocialAccountsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListSocialAccountsKey = 'ListSocialAccounts';
export const UseListSocialAccountsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListSocialAccountsKey, ...(queryKey ?? [clientOptions])];
export type GetSocialAccountDefaultResponse = Awaited<ReturnType<typeof getSocialAccount>>['data'];
export type GetSocialAccountQueryResult<
  TData = GetSocialAccountDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSocialAccountKey = 'GetSocialAccount';
export const UseGetSocialAccountKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetSocialAccountKey, ...(queryKey ?? [clientOptions])];
export type GetSocialAccountWorkflowsDefaultResponse = Awaited<
  ReturnType<typeof getSocialAccountWorkflows>
>['data'];
export type GetSocialAccountWorkflowsQueryResult<
  TData = GetSocialAccountWorkflowsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSocialAccountWorkflowsKey = 'GetSocialAccountWorkflows';
export const UseGetSocialAccountWorkflowsKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetSocialAccountWorkflowsKey, ...(queryKey ?? [clientOptions])];
export type ExportSocialBrowserStateDefaultResponse = Awaited<
  ReturnType<typeof exportSocialBrowserState>
>['data'];
export type ExportSocialBrowserStateQueryResult<
  TData = ExportSocialBrowserStateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useExportSocialBrowserStateKey = 'ExportSocialBrowserState';
export const UseExportSocialBrowserStateKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useExportSocialBrowserStateKey, ...(queryKey ?? [clientOptions])];
export type ListSocialAccountCategoriesDefaultResponse = Awaited<
  ReturnType<typeof listSocialAccountCategories>
>['data'];
export type ListSocialAccountCategoriesQueryResult<
  TData = ListSocialAccountCategoriesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListSocialAccountCategoriesKey = 'ListSocialAccountCategories';
export const UseListSocialAccountCategoriesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListSocialAccountCategoriesKey, ...(queryKey ?? [clientOptions])];
export type GetSocialAccountCategoryDefaultResponse = Awaited<
  ReturnType<typeof getSocialAccountCategory>
>['data'];
export type GetSocialAccountCategoryQueryResult<
  TData = GetSocialAccountCategoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSocialAccountCategoryKey = 'GetSocialAccountCategory';
export const UseGetSocialAccountCategoryKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetSocialAccountCategoryKey, ...(queryKey ?? [clientOptions])];
export type ListSocialAccountsByCategoryDefaultResponse = Awaited<
  ReturnType<typeof listSocialAccountsByCategory>
>['data'];
export type ListSocialAccountsByCategoryQueryResult<
  TData = ListSocialAccountsByCategoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListSocialAccountsByCategoryKey = 'ListSocialAccountsByCategory';
export const UseListSocialAccountsByCategoryKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useListSocialAccountsByCategoryKey, ...(queryKey ?? [clientOptions])];
export type ListCategoriesBySocialAccountDefaultResponse = Awaited<
  ReturnType<typeof listCategoriesBySocialAccount>
>['data'];
export type ListCategoriesBySocialAccountQueryResult<
  TData = ListCategoriesBySocialAccountDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListCategoriesBySocialAccountKey = 'ListCategoriesBySocialAccount';
export const UseListCategoriesBySocialAccountKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useListCategoriesBySocialAccountKey, ...(queryKey ?? [clientOptions])];
export type GetVideoEditProjectDefaultResponse = Awaited<
  ReturnType<typeof getVideoEditProject>
>['data'];
export type GetVideoEditProjectQueryResult<
  TData = GetVideoEditProjectDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetVideoEditProjectKey = 'GetVideoEditProject';
export const UseGetVideoEditProjectKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetVideoEditProjectKey, ...(queryKey ?? [clientOptions])];
export type GetVideoEditVersionDefaultResponse = Awaited<
  ReturnType<typeof getVideoEditVersion>
>['data'];
export type GetVideoEditVersionQueryResult<
  TData = GetVideoEditVersionDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetVideoEditVersionKey = 'GetVideoEditVersion';
export const UseGetVideoEditVersionKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetVideoEditVersionKey, ...(queryKey ?? [clientOptions])];
export type GetVideoEditProjectSnapshotDefaultResponse = Awaited<
  ReturnType<typeof getVideoEditProjectSnapshot>
>['data'];
export type GetVideoEditProjectSnapshotQueryResult<
  TData = GetVideoEditProjectSnapshotDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetVideoEditProjectSnapshotKey = 'GetVideoEditProjectSnapshot';
export const UseGetVideoEditProjectSnapshotKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetVideoEditProjectSnapshotKey, ...(queryKey ?? [clientOptions])];
export type GetVideoEditAssetAccessUrlDefaultResponse = Awaited<
  ReturnType<typeof getVideoEditAssetAccessUrl>
>['data'];
export type GetVideoEditAssetAccessUrlQueryResult<
  TData = GetVideoEditAssetAccessUrlDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetVideoEditAssetAccessUrlKey = 'GetVideoEditAssetAccessUrl';
export const UseGetVideoEditAssetAccessUrlKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetVideoEditAssetAccessUrlKey, ...(queryKey ?? [clientOptions])];
export type GetProductionStudioWorkspaceDefaultResponse = Awaited<
  ReturnType<typeof getProductionStudioWorkspace>
>['data'];
export type GetProductionStudioWorkspaceQueryResult<
  TData = GetProductionStudioWorkspaceDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetProductionStudioWorkspaceKey = 'GetProductionStudioWorkspace';
export const UseGetProductionStudioWorkspaceKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetProductionStudioWorkspaceKey, ...(queryKey ?? [clientOptions])];
export type ListProductionStudioClientPacksDefaultResponse = Awaited<
  ReturnType<typeof listProductionStudioClientPacks>
>['data'];
export type ListProductionStudioClientPacksQueryResult<
  TData = ListProductionStudioClientPacksDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListProductionStudioClientPacksKey = 'ListProductionStudioClientPacks';
export const UseListProductionStudioClientPacksKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListProductionStudioClientPacksKey, ...(queryKey ?? [clientOptions])];
export type GetProductionStudioBatchDefaultResponse = Awaited<
  ReturnType<typeof getProductionStudioBatch>
>['data'];
export type GetProductionStudioBatchQueryResult<
  TData = GetProductionStudioBatchDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetProductionStudioBatchKey = 'GetProductionStudioBatch';
export const UseGetProductionStudioBatchKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetProductionStudioBatchKey, ...(queryKey ?? [clientOptions])];
export type GetProductionStudioOutputAccessUrlDefaultResponse = Awaited<
  ReturnType<typeof getProductionStudioOutputAccessUrl>
>['data'];
export type GetProductionStudioOutputAccessUrlQueryResult<
  TData = GetProductionStudioOutputAccessUrlDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetProductionStudioOutputAccessUrlKey = 'GetProductionStudioOutputAccessUrl';
export const UseGetProductionStudioOutputAccessUrlKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetProductionStudioOutputAccessUrlKey, ...(queryKey ?? [clientOptions])];
export type GetProductionStudioOutputStrategyArtifactDefaultResponse = Awaited<
  ReturnType<typeof getProductionStudioOutputStrategyArtifact>
>['data'];
export type GetProductionStudioOutputStrategyArtifactQueryResult<
  TData = GetProductionStudioOutputStrategyArtifactDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetProductionStudioOutputStrategyArtifactKey =
  'GetProductionStudioOutputStrategyArtifact';
export const UseGetProductionStudioOutputStrategyArtifactKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetProductionStudioOutputStrategyArtifactKey, ...(queryKey ?? [clientOptions])];
export type GetSocialBrowserSessionDefaultResponse = Awaited<
  ReturnType<typeof getSocialBrowserSession>
>['data'];
export type GetSocialBrowserSessionQueryResult<
  TData = GetSocialBrowserSessionDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSocialBrowserSessionKey = 'GetSocialBrowserSession';
export const UseGetSocialBrowserSessionKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetSocialBrowserSessionKey, ...(queryKey ?? [clientOptions])];
export type GetActiveSocialBrowserSessionBatchDefaultResponse = Awaited<
  ReturnType<typeof getActiveSocialBrowserSessionBatch>
>['data'];
export type GetActiveSocialBrowserSessionBatchQueryResult<
  TData = GetActiveSocialBrowserSessionBatchDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetActiveSocialBrowserSessionBatchKey = 'GetActiveSocialBrowserSessionBatch';
export const UseGetActiveSocialBrowserSessionBatchKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetActiveSocialBrowserSessionBatchKey, ...(queryKey ?? [clientOptions])];
export type GetSocialBrowserSessionBatchDefaultResponse = Awaited<
  ReturnType<typeof getSocialBrowserSessionBatch>
>['data'];
export type GetSocialBrowserSessionBatchQueryResult<
  TData = GetSocialBrowserSessionBatchDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSocialBrowserSessionBatchKey = 'GetSocialBrowserSessionBatch';
export const UseGetSocialBrowserSessionBatchKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetSocialBrowserSessionBatchKey, ...(queryKey ?? [clientOptions])];
export type GetSocialPublishExecutorStatusDefaultResponse = Awaited<
  ReturnType<typeof getSocialPublishExecutorStatus>
>['data'];
export type GetSocialPublishExecutorStatusQueryResult<
  TData = GetSocialPublishExecutorStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSocialPublishExecutorStatusKey = 'GetSocialPublishExecutorStatus';
export const UseGetSocialPublishExecutorStatusKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetSocialPublishExecutorStatusKey, ...(queryKey ?? [clientOptions])];
export type ListMediaLibraryEntriesDefaultResponse = Awaited<
  ReturnType<typeof listMediaLibraryEntries>
>['data'];
export type ListMediaLibraryEntriesQueryResult<
  TData = ListMediaLibraryEntriesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListMediaLibraryEntriesKey = 'ListMediaLibraryEntries';
export const UseListMediaLibraryEntriesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListMediaLibraryEntriesKey, ...(queryKey ?? [clientOptions])];
export type SearchMediaLibraryEntriesDefaultResponse = Awaited<
  ReturnType<typeof searchMediaLibraryEntries>
>['data'];
export type SearchMediaLibraryEntriesQueryResult<
  TData = SearchMediaLibraryEntriesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSearchMediaLibraryEntriesKey = 'SearchMediaLibraryEntries';
export const UseSearchMediaLibraryEntriesKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useSearchMediaLibraryEntriesKey, ...(queryKey ?? [clientOptions])];
export type GetMediaLibraryEntryDefaultResponse = Awaited<
  ReturnType<typeof getMediaLibraryEntry>
>['data'];
export type GetMediaLibraryEntryQueryResult<
  TData = GetMediaLibraryEntryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetMediaLibraryEntryKey = 'GetMediaLibraryEntry';
export const UseGetMediaLibraryEntryKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetMediaLibraryEntryKey, ...(queryKey ?? [clientOptions])];
export type GetMediaLibraryEntryAccessUrlDefaultResponse = Awaited<
  ReturnType<typeof getMediaLibraryEntryAccessUrl>
>['data'];
export type GetMediaLibraryEntryAccessUrlQueryResult<
  TData = GetMediaLibraryEntryAccessUrlDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetMediaLibraryEntryAccessUrlKey = 'GetMediaLibraryEntryAccessUrl';
export const UseGetMediaLibraryEntryAccessUrlKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetMediaLibraryEntryAccessUrlKey, ...(queryKey ?? [clientOptions])];
export type GetMediaLibraryUploadStatusDefaultResponse = Awaited<
  ReturnType<typeof getMediaLibraryUploadStatus>
>['data'];
export type GetMediaLibraryUploadStatusQueryResult<
  TData = GetMediaLibraryUploadStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetMediaLibraryUploadStatusKey = 'GetMediaLibraryUploadStatus';
export const UseGetMediaLibraryUploadStatusKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetMediaLibraryUploadStatusKey, ...(queryKey ?? [clientOptions])];
export type GetMediaLibraryDownloadTaskDefaultResponse = Awaited<
  ReturnType<typeof getMediaLibraryDownloadTask>
>['data'];
export type GetMediaLibraryDownloadTaskQueryResult<
  TData = GetMediaLibraryDownloadTaskDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetMediaLibraryDownloadTaskKey = 'GetMediaLibraryDownloadTask';
export const UseGetMediaLibraryDownloadTaskKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetMediaLibraryDownloadTaskKey, ...(queryKey ?? [clientOptions])];
export type ListCanvasMaterialsDefaultResponse = Awaited<
  ReturnType<typeof listCanvasMaterials>
>['data'];
export type ListCanvasMaterialsQueryResult<
  TData = ListCanvasMaterialsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListCanvasMaterialsKey = 'ListCanvasMaterials';
export const UseListCanvasMaterialsKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useListCanvasMaterialsKey, ...(queryKey ?? [clientOptions])];
export type GetCanvasMaterialAccessUrlDefaultResponse = Awaited<
  ReturnType<typeof getCanvasMaterialAccessUrl>
>['data'];
export type GetCanvasMaterialAccessUrlQueryResult<
  TData = GetCanvasMaterialAccessUrlDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCanvasMaterialAccessUrlKey = 'GetCanvasMaterialAccessUrl';
export const UseGetCanvasMaterialAccessUrlKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCanvasMaterialAccessUrlKey, ...(queryKey ?? [clientOptions])];
export type GetCanvasMaterialDownloadTaskDefaultResponse = Awaited<
  ReturnType<typeof getCanvasMaterialDownloadTask>
>['data'];
export type GetCanvasMaterialDownloadTaskQueryResult<
  TData = GetCanvasMaterialDownloadTaskDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCanvasMaterialDownloadTaskKey = 'GetCanvasMaterialDownloadTask';
export const UseGetCanvasMaterialDownloadTaskKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCanvasMaterialDownloadTaskKey, ...(queryKey ?? [clientOptions])];
export type ListMcpServersDefaultResponse = Awaited<ReturnType<typeof listMcpServers>>['data'];
export type ListMcpServersQueryResult<
  TData = ListMcpServersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListMcpServersKey = 'ListMcpServers';
export const UseListMcpServersKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListMcpServersKey, ...(queryKey ?? [clientOptions])];
export type ListPagesDefaultResponse = Awaited<ReturnType<typeof listPages>>['data'];
export type ListPagesQueryResult<
  TData = ListPagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListPagesKey = 'ListPages';
export const UseListPagesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListPagesKey, ...(queryKey ?? [clientOptions])];
export type GetPageDetailDefaultResponse = Awaited<ReturnType<typeof getPageDetail>>['data'];
export type GetPageDetailQueryResult<
  TData = GetPageDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetPageDetailKey = 'GetPageDetail';
export const UseGetPageDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetPageDetailKey, ...(queryKey ?? [clientOptions])];
export type GetPageByCanvasIdDefaultResponse = Awaited<
  ReturnType<typeof getPageByCanvasId>
>['data'];
export type GetPageByCanvasIdQueryResult<
  TData = GetPageByCanvasIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetPageByCanvasIdKey = 'GetPageByCanvasId';
export const UseGetPageByCanvasIdKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetPageByCanvasIdKey, ...(queryKey ?? [clientOptions])];
export type GetAuthConfigDefaultResponse = Awaited<ReturnType<typeof getAuthConfig>>['data'];
export type GetAuthConfigQueryResult<
  TData = GetAuthConfigDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetAuthConfigKey = 'GetAuthConfig';
export const UseGetAuthConfigKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetAuthConfigKey, ...(queryKey ?? [clientOptions])];
export type CheckToolOauthStatusDefaultResponse = Awaited<
  ReturnType<typeof checkToolOauthStatus>
>['data'];
export type CheckToolOauthStatusQueryResult<
  TData = CheckToolOauthStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCheckToolOauthStatusKey = 'CheckToolOauthStatus';
export const UseCheckToolOauthStatusKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useCheckToolOauthStatusKey, ...(queryKey ?? [clientOptions])];
export type GetCollabTokenDefaultResponse = Awaited<ReturnType<typeof getCollabToken>>['data'];
export type GetCollabTokenQueryResult<
  TData = GetCollabTokenDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCollabTokenKey = 'GetCollabToken';
export const UseGetCollabTokenKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetCollabTokenKey, ...(queryKey ?? [clientOptions])];
export type ListCanvasesDefaultResponse = Awaited<ReturnType<typeof listCanvases>>['data'];
export type ListCanvasesQueryResult<
  TData = ListCanvasesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListCanvasesKey = 'ListCanvases';
export const UseListCanvasesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListCanvasesKey, ...(queryKey ?? [clientOptions])];
export type GetCanvasDetailDefaultResponse = Awaited<ReturnType<typeof getCanvasDetail>>['data'];
export type GetCanvasDetailQueryResult<
  TData = GetCanvasDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCanvasDetailKey = 'GetCanvasDetail';
export const UseGetCanvasDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCanvasDetailKey, ...(queryKey ?? [clientOptions])];
export type GetCanvasDataDefaultResponse = Awaited<ReturnType<typeof getCanvasData>>['data'];
export type GetCanvasDataQueryResult<
  TData = GetCanvasDataDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCanvasDataKey = 'GetCanvasData';
export const UseGetCanvasDataKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCanvasDataKey, ...(queryKey ?? [clientOptions])];
export type ExportCanvasDefaultResponse = Awaited<ReturnType<typeof exportCanvas>>['data'];
export type ExportCanvasQueryResult<
  TData = ExportCanvasDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useExportCanvasKey = 'ExportCanvas';
export const UseExportCanvasKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useExportCanvasKey, ...(queryKey ?? [clientOptions])];
export type GetCanvasStateDefaultResponse = Awaited<ReturnType<typeof getCanvasState>>['data'];
export type GetCanvasStateQueryResult<
  TData = GetCanvasStateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCanvasStateKey = 'GetCanvasState';
export const UseGetCanvasStateKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCanvasStateKey, ...(queryKey ?? [clientOptions])];
export type GetCanvasTransactionsDefaultResponse = Awaited<
  ReturnType<typeof getCanvasTransactions>
>['data'];
export type GetCanvasTransactionsQueryResult<
  TData = GetCanvasTransactionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCanvasTransactionsKey = 'GetCanvasTransactions';
export const UseGetCanvasTransactionsKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCanvasTransactionsKey, ...(queryKey ?? [clientOptions])];
export type GetWorkflowVariablesDefaultResponse = Awaited<
  ReturnType<typeof getWorkflowVariables>
>['data'];
export type GetWorkflowVariablesQueryResult<
  TData = GetWorkflowVariablesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetWorkflowVariablesKey = 'GetWorkflowVariables';
export const UseGetWorkflowVariablesKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetWorkflowVariablesKey, ...(queryKey ?? [clientOptions])];
export type ListDriveFilesDefaultResponse = Awaited<ReturnType<typeof listDriveFiles>>['data'];
export type ListDriveFilesQueryResult<
  TData = ListDriveFilesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListDriveFilesKey = 'ListDriveFiles';
export const UseListDriveFilesKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useListDriveFilesKey, ...(queryKey ?? [clientOptions])];
export type ListCanvasTemplatesDefaultResponse = Awaited<
  ReturnType<typeof listCanvasTemplates>
>['data'];
export type ListCanvasTemplatesQueryResult<
  TData = ListCanvasTemplatesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListCanvasTemplatesKey = 'ListCanvasTemplates';
export const UseListCanvasTemplatesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListCanvasTemplatesKey, ...(queryKey ?? [clientOptions])];
export type ListCanvasTemplateCategoriesDefaultResponse = Awaited<
  ReturnType<typeof listCanvasTemplateCategories>
>['data'];
export type ListCanvasTemplateCategoriesQueryResult<
  TData = ListCanvasTemplateCategoriesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListCanvasTemplateCategoriesKey = 'ListCanvasTemplateCategories';
export const UseListCanvasTemplateCategoriesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListCanvasTemplateCategoriesKey, ...(queryKey ?? [clientOptions])];
export type ListResourcesDefaultResponse = Awaited<ReturnType<typeof listResources>>['data'];
export type ListResourcesQueryResult<
  TData = ListResourcesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListResourcesKey = 'ListResources';
export const UseListResourcesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListResourcesKey, ...(queryKey ?? [clientOptions])];
export type GetResourceDetailDefaultResponse = Awaited<
  ReturnType<typeof getResourceDetail>
>['data'];
export type GetResourceDetailQueryResult<
  TData = GetResourceDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetResourceDetailKey = 'GetResourceDetail';
export const UseGetResourceDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetResourceDetailKey, ...(queryKey ?? [clientOptions])];
export type ListDocumentsDefaultResponse = Awaited<ReturnType<typeof listDocuments>>['data'];
export type ListDocumentsQueryResult<
  TData = ListDocumentsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListDocumentsKey = 'ListDocuments';
export const UseListDocumentsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListDocumentsKey, ...(queryKey ?? [clientOptions])];
export type GetDocumentDetailDefaultResponse = Awaited<
  ReturnType<typeof getDocumentDetail>
>['data'];
export type GetDocumentDetailQueryResult<
  TData = GetDocumentDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetDocumentDetailKey = 'GetDocumentDetail';
export const UseGetDocumentDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetDocumentDetailKey, ...(queryKey ?? [clientOptions])];
export type ExportDocumentDefaultResponse = Awaited<ReturnType<typeof exportDocument>>['data'];
export type ExportDocumentQueryResult<
  TData = ExportDocumentDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useExportDocumentKey = 'ExportDocument';
export const UseExportDocumentKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useExportDocumentKey, ...(queryKey ?? [clientOptions])];
export type GetExportJobStatusDefaultResponse = Awaited<
  ReturnType<typeof getExportJobStatus>
>['data'];
export type GetExportJobStatusQueryResult<
  TData = GetExportJobStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetExportJobStatusKey = 'GetExportJobStatus';
export const UseGetExportJobStatusKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetExportJobStatusKey, ...(queryKey ?? [clientOptions])];
export type DownloadExportJobResultDefaultResponse = Awaited<
  ReturnType<typeof downloadExportJobResult>
>['data'];
export type DownloadExportJobResultQueryResult<
  TData = DownloadExportJobResultDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDownloadExportJobResultKey = 'DownloadExportJobResult';
export const UseDownloadExportJobResultKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useDownloadExportJobResultKey, ...(queryKey ?? [clientOptions])];
export type ListProjectsDefaultResponse = Awaited<ReturnType<typeof listProjects>>['data'];
export type ListProjectsQueryResult<
  TData = ListProjectsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListProjectsKey = 'ListProjects';
export const UseListProjectsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListProjectsKey, ...(queryKey ?? [clientOptions])];
export type GetProjectDetailDefaultResponse = Awaited<ReturnType<typeof getProjectDetail>>['data'];
export type GetProjectDetailQueryResult<
  TData = GetProjectDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetProjectDetailKey = 'GetProjectDetail';
export const UseGetProjectDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetProjectDetailKey, ...(queryKey ?? [clientOptions])];
export type ListCodeArtifactsDefaultResponse = Awaited<
  ReturnType<typeof listCodeArtifacts>
>['data'];
export type ListCodeArtifactsQueryResult<
  TData = ListCodeArtifactsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListCodeArtifactsKey = 'ListCodeArtifacts';
export const UseListCodeArtifactsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListCodeArtifactsKey, ...(queryKey ?? [clientOptions])];
export type GetCodeArtifactDetailDefaultResponse = Awaited<
  ReturnType<typeof getCodeArtifactDetail>
>['data'];
export type GetCodeArtifactDetailQueryResult<
  TData = GetCodeArtifactDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCodeArtifactDetailKey = 'GetCodeArtifactDetail';
export const UseGetCodeArtifactDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCodeArtifactDetailKey, ...(queryKey ?? [clientOptions])];
export type ListSharesDefaultResponse = Awaited<ReturnType<typeof listShares>>['data'];
export type ListSharesQueryResult<
  TData = ListSharesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListSharesKey = 'ListShares';
export const UseListSharesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListSharesKey, ...(queryKey ?? [clientOptions])];
export type ListLabelClassesDefaultResponse = Awaited<ReturnType<typeof listLabelClasses>>['data'];
export type ListLabelClassesQueryResult<
  TData = ListLabelClassesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListLabelClassesKey = 'ListLabelClasses';
export const UseListLabelClassesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListLabelClassesKey, ...(queryKey ?? [clientOptions])];
export type ListLabelInstancesDefaultResponse = Awaited<
  ReturnType<typeof listLabelInstances>
>['data'];
export type ListLabelInstancesQueryResult<
  TData = ListLabelInstancesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListLabelInstancesKey = 'ListLabelInstances';
export const UseListLabelInstancesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListLabelInstancesKey, ...(queryKey ?? [clientOptions])];
export type GetActionResultDefaultResponse = Awaited<ReturnType<typeof getActionResult>>['data'];
export type GetActionResultQueryResult<
  TData = GetActionResultDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetActionResultKey = 'GetActionResult';
export const UseGetActionResultKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetActionResultKey, ...(queryKey ?? [clientOptions])];
export type ListSkillsDefaultResponse = Awaited<ReturnType<typeof listSkills>>['data'];
export type ListSkillsQueryResult<
  TData = ListSkillsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListSkillsKey = 'ListSkills';
export const UseListSkillsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListSkillsKey, ...(queryKey ?? [clientOptions])];
export type ListSkillInstancesDefaultResponse = Awaited<
  ReturnType<typeof listSkillInstances>
>['data'];
export type ListSkillInstancesQueryResult<
  TData = ListSkillInstancesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListSkillInstancesKey = 'ListSkillInstances';
export const UseListSkillInstancesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListSkillInstancesKey, ...(queryKey ?? [clientOptions])];
export type ListSkillTriggersDefaultResponse = Awaited<
  ReturnType<typeof listSkillTriggers>
>['data'];
export type ListSkillTriggersQueryResult<
  TData = ListSkillTriggersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListSkillTriggersKey = 'ListSkillTriggers';
export const UseListSkillTriggersKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListSkillTriggersKey, ...(queryKey ?? [clientOptions])];
export type ListPilotSessionsDefaultResponse = Awaited<
  ReturnType<typeof listPilotSessions>
>['data'];
export type ListPilotSessionsQueryResult<
  TData = ListPilotSessionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListPilotSessionsKey = 'ListPilotSessions';
export const UseListPilotSessionsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListPilotSessionsKey, ...(queryKey ?? [clientOptions])];
export type GetPilotSessionDetailDefaultResponse = Awaited<
  ReturnType<typeof getPilotSessionDetail>
>['data'];
export type GetPilotSessionDetailQueryResult<
  TData = GetPilotSessionDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetPilotSessionDetailKey = 'GetPilotSessionDetail';
export const UseGetPilotSessionDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetPilotSessionDetailKey, ...(queryKey ?? [clientOptions])];
export type ListCopilotSessionsDefaultResponse = Awaited<
  ReturnType<typeof listCopilotSessions>
>['data'];
export type ListCopilotSessionsQueryResult<
  TData = ListCopilotSessionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListCopilotSessionsKey = 'ListCopilotSessions';
export const UseListCopilotSessionsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListCopilotSessionsKey, ...(queryKey ?? [clientOptions])];
export type GetCopilotSessionDetailDefaultResponse = Awaited<
  ReturnType<typeof getCopilotSessionDetail>
>['data'];
export type GetCopilotSessionDetailQueryResult<
  TData = GetCopilotSessionDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCopilotSessionDetailKey = 'GetCopilotSessionDetail';
export const UseGetCopilotSessionDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCopilotSessionDetailKey, ...(queryKey ?? [clientOptions])];
export type ListWorkflowExecutionsDefaultResponse = Awaited<
  ReturnType<typeof listWorkflowExecutions>
>['data'];
export type ListWorkflowExecutionsQueryResult<
  TData = ListWorkflowExecutionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListWorkflowExecutionsKey = 'ListWorkflowExecutions';
export const UseListWorkflowExecutionsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListWorkflowExecutionsKey, ...(queryKey ?? [clientOptions])];
export type GetWorkflowDetailDefaultResponse = Awaited<
  ReturnType<typeof getWorkflowDetail>
>['data'];
export type GetWorkflowDetailQueryResult<
  TData = GetWorkflowDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetWorkflowDetailKey = 'GetWorkflowDetail';
export const UseGetWorkflowDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetWorkflowDetailKey, ...(queryKey ?? [clientOptions])];
export type GetWorkflowPlanDetailDefaultResponse = Awaited<
  ReturnType<typeof getWorkflowPlanDetail>
>['data'];
export type GetWorkflowPlanDetailQueryResult<
  TData = GetWorkflowPlanDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetWorkflowPlanDetailKey = 'GetWorkflowPlanDetail';
export const UseGetWorkflowPlanDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetWorkflowPlanDetailKey, ...(queryKey ?? [clientOptions])];
export type GetWorkflowAppDetailDefaultResponse = Awaited<
  ReturnType<typeof getWorkflowAppDetail>
>['data'];
export type GetWorkflowAppDetailQueryResult<
  TData = GetWorkflowAppDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetWorkflowAppDetailKey = 'GetWorkflowAppDetail';
export const UseGetWorkflowAppDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetWorkflowAppDetailKey, ...(queryKey ?? [clientOptions])];
export type ListWorkflowAppsDefaultResponse = Awaited<ReturnType<typeof listWorkflowApps>>['data'];
export type ListWorkflowAppsQueryResult<
  TData = ListWorkflowAppsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListWorkflowAppsKey = 'ListWorkflowApps';
export const UseListWorkflowAppsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListWorkflowAppsKey, ...(queryKey ?? [clientOptions])];
export type GetTemplateGenerationStatusDefaultResponse = Awaited<
  ReturnType<typeof getTemplateGenerationStatus>
>['data'];
export type GetTemplateGenerationStatusQueryResult<
  TData = GetTemplateGenerationStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetTemplateGenerationStatusKey = 'GetTemplateGenerationStatus';
export const UseGetTemplateGenerationStatusKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetTemplateGenerationStatusKey, ...(queryKey ?? [clientOptions])];
export type ListCliApiKeysDefaultResponse = Awaited<ReturnType<typeof listCliApiKeys>>['data'];
export type ListCliApiKeysQueryResult<
  TData = ListCliApiKeysDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListCliApiKeysKey = 'ListCliApiKeys';
export const UseListCliApiKeysKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListCliApiKeysKey, ...(queryKey ?? [clientOptions])];
export type GetOpenapiConfigDefaultResponse = Awaited<ReturnType<typeof getOpenapiConfig>>['data'];
export type GetOpenapiConfigQueryResult<
  TData = GetOpenapiConfigDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetOpenapiConfigKey = 'GetOpenapiConfig';
export const UseGetOpenapiConfigKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetOpenapiConfigKey, ...(queryKey ?? [clientOptions])];
export type SearchWorkflowsViaApiDefaultResponse = Awaited<
  ReturnType<typeof searchWorkflowsViaApi>
>['data'];
export type SearchWorkflowsViaApiQueryResult<
  TData = SearchWorkflowsViaApiDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSearchWorkflowsViaApiKey = 'SearchWorkflowsViaApi';
export const UseSearchWorkflowsViaApiKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useSearchWorkflowsViaApiKey, ...(queryKey ?? [clientOptions])];
export type GetWorkflowDetailViaApiDefaultResponse = Awaited<
  ReturnType<typeof getWorkflowDetailViaApi>
>['data'];
export type GetWorkflowDetailViaApiQueryResult<
  TData = GetWorkflowDetailViaApiDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetWorkflowDetailViaApiKey = 'GetWorkflowDetailViaApi';
export const UseGetWorkflowDetailViaApiKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetWorkflowDetailViaApiKey, ...(queryKey ?? [clientOptions])];
export type GetWorkflowStatusViaApiDefaultResponse = Awaited<
  ReturnType<typeof getWorkflowStatusViaApi>
>['data'];
export type GetWorkflowStatusViaApiQueryResult<
  TData = GetWorkflowStatusViaApiDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetWorkflowStatusViaApiKey = 'GetWorkflowStatusViaApi';
export const UseGetWorkflowStatusViaApiKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetWorkflowStatusViaApiKey, ...(queryKey ?? [clientOptions])];
export type GetWorkflowOutputDefaultResponse = Awaited<
  ReturnType<typeof getWorkflowOutput>
>['data'];
export type GetWorkflowOutputQueryResult<
  TData = GetWorkflowOutputDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetWorkflowOutputKey = 'GetWorkflowOutput';
export const UseGetWorkflowOutputKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetWorkflowOutputKey, ...(queryKey ?? [clientOptions])];
export type GetSettingsDefaultResponse = Awaited<ReturnType<typeof getSettings>>['data'];
export type GetSettingsQueryResult<
  TData = GetSettingsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSettingsKey = 'GetSettings';
export const UseGetSettingsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetSettingsKey, ...(queryKey ?? [clientOptions])];
export type CheckSettingsFieldDefaultResponse = Awaited<
  ReturnType<typeof checkSettingsField>
>['data'];
export type CheckSettingsFieldQueryResult<
  TData = CheckSettingsFieldDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCheckSettingsFieldKey = 'CheckSettingsField';
export const UseCheckSettingsFieldKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useCheckSettingsFieldKey, ...(queryKey ?? [clientOptions])];
export type GetFormDefinitionDefaultResponse = Awaited<
  ReturnType<typeof getFormDefinition>
>['data'];
export type GetFormDefinitionQueryResult<
  TData = GetFormDefinitionDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetFormDefinitionKey = 'GetFormDefinition';
export const UseGetFormDefinitionKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetFormDefinitionKey, ...(queryKey ?? [clientOptions])];
export type HasFilledFormDefaultResponse = Awaited<ReturnType<typeof hasFilledForm>>['data'];
export type HasFilledFormQueryResult<
  TData = HasFilledFormDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHasFilledFormKey = 'HasFilledForm';
export const UseHasFilledFormKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useHasFilledFormKey, ...(queryKey ?? [clientOptions])];
export type GetCreditRechargeDefaultResponse = Awaited<
  ReturnType<typeof getCreditRecharge>
>['data'];
export type GetCreditRechargeQueryResult<
  TData = GetCreditRechargeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCreditRechargeKey = 'GetCreditRecharge';
export const UseGetCreditRechargeKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetCreditRechargeKey, ...(queryKey ?? [clientOptions])];
export type GetCreditUsageDefaultResponse = Awaited<ReturnType<typeof getCreditUsage>>['data'];
export type GetCreditUsageQueryResult<
  TData = GetCreditUsageDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCreditUsageKey = 'GetCreditUsage';
export const UseGetCreditUsageKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetCreditUsageKey, ...(queryKey ?? [clientOptions])];
export type GetCreditBalanceDefaultResponse = Awaited<ReturnType<typeof getCreditBalance>>['data'];
export type GetCreditBalanceQueryResult<
  TData = GetCreditBalanceDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCreditBalanceKey = 'GetCreditBalance';
export const UseGetCreditBalanceKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetCreditBalanceKey, ...(queryKey ?? [clientOptions])];
export type GetCreditUsageByResultIdDefaultResponse = Awaited<
  ReturnType<typeof getCreditUsageByResultId>
>['data'];
export type GetCreditUsageByResultIdQueryResult<
  TData = GetCreditUsageByResultIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCreditUsageByResultIdKey = 'GetCreditUsageByResultId';
export const UseGetCreditUsageByResultIdKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCreditUsageByResultIdKey, ...(queryKey ?? [clientOptions])];
export type GetCreditUsageByExecutionIdDefaultResponse = Awaited<
  ReturnType<typeof getCreditUsageByExecutionId>
>['data'];
export type GetCreditUsageByExecutionIdQueryResult<
  TData = GetCreditUsageByExecutionIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCreditUsageByExecutionIdKey = 'GetCreditUsageByExecutionId';
export const UseGetCreditUsageByExecutionIdKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCreditUsageByExecutionIdKey, ...(queryKey ?? [clientOptions])];
export type GetCreditUsageByCanvasIdDefaultResponse = Awaited<
  ReturnType<typeof getCreditUsageByCanvasId>
>['data'];
export type GetCreditUsageByCanvasIdQueryResult<
  TData = GetCreditUsageByCanvasIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetCreditUsageByCanvasIdKey = 'GetCreditUsageByCanvasId';
export const UseGetCreditUsageByCanvasIdKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetCreditUsageByCanvasIdKey, ...(queryKey ?? [clientOptions])];
export type ListInvitationCodesDefaultResponse = Awaited<
  ReturnType<typeof listInvitationCodes>
>['data'];
export type ListInvitationCodesQueryResult<
  TData = ListInvitationCodesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListInvitationCodesKey = 'ListInvitationCodes';
export const UseListInvitationCodesKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListInvitationCodesKey, ...(queryKey ?? [clientOptions])];
export type HasBeenInvitedDefaultResponse = Awaited<ReturnType<typeof hasBeenInvited>>['data'];
export type HasBeenInvitedQueryResult<
  TData = HasBeenInvitedDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHasBeenInvitedKey = 'HasBeenInvited';
export const UseHasBeenInvitedKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useHasBeenInvitedKey, ...(queryKey ?? [clientOptions])];
export type GetSubscriptionPlansDefaultResponse = Awaited<
  ReturnType<typeof getSubscriptionPlans>
>['data'];
export type GetSubscriptionPlansQueryResult<
  TData = GetSubscriptionPlansDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSubscriptionPlansKey = 'GetSubscriptionPlans';
export const UseGetSubscriptionPlansKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetSubscriptionPlansKey, ...(queryKey ?? [clientOptions])];
export type GetSubscriptionUsageDefaultResponse = Awaited<
  ReturnType<typeof getSubscriptionUsage>
>['data'];
export type GetSubscriptionUsageQueryResult<
  TData = GetSubscriptionUsageDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetSubscriptionUsageKey = 'GetSubscriptionUsage';
export const UseGetSubscriptionUsageKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetSubscriptionUsageKey, ...(queryKey ?? [clientOptions])];
export type ListModelsDefaultResponse = Awaited<ReturnType<typeof listModels>>['data'];
export type ListModelsQueryResult<
  TData = ListModelsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListModelsKey = 'ListModels';
export const UseListModelsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListModelsKey, ...(queryKey ?? [clientOptions])];
export type GetPayOrderDefaultResponse = Awaited<ReturnType<typeof getPayOrder>>['data'];
export type GetPayOrderQueryResult<
  TData = GetPayOrderDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetPayOrderKey = 'GetPayOrder';
export const UseGetPayOrderKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetPayOrderKey, ...(queryKey ?? [clientOptions])];
export type GetModelOptionsDefaultResponse = Awaited<ReturnType<typeof getModelOptions>>['data'];
export type GetModelOptionsQueryResult<
  TData = GetModelOptionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetModelOptionsKey = 'GetModelOptions';
export const UseGetModelOptionsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetModelOptionsKey, ...(queryKey ?? [clientOptions])];
export type ListManagedModelsDefaultResponse = Awaited<
  ReturnType<typeof listManagedModels>
>['data'];
export type ListManagedModelsQueryResult<
  TData = ListManagedModelsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListManagedModelsKey = 'ListManagedModels';
export const UseListManagedModelsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListManagedModelsKey, ...(queryKey ?? [clientOptions])];
export type ListProvidersDefaultResponse = Awaited<ReturnType<typeof listProviders>>['data'];
export type ListProvidersQueryResult<
  TData = ListProvidersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListProvidersKey = 'ListProviders';
export const UseListProvidersKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListProvidersKey, ...(queryKey ?? [clientOptions])];
export type ListProviderItemsDefaultResponse = Awaited<
  ReturnType<typeof listProviderItems>
>['data'];
export type ListProviderItemsQueryResult<
  TData = ListProviderItemsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListProviderItemsKey = 'ListProviderItems';
export const UseListProviderItemsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListProviderItemsKey, ...(queryKey ?? [clientOptions])];
export type ListProviderItemOptionsDefaultResponse = Awaited<
  ReturnType<typeof listProviderItemOptions>
>['data'];
export type ListProviderItemOptionsQueryResult<
  TData = ListProviderItemOptionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListProviderItemOptionsKey = 'ListProviderItemOptions';
export const UseListProviderItemOptionsKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useListProviderItemOptionsKey, ...(queryKey ?? [clientOptions])];
export type ListToolsDefaultResponse = Awaited<ReturnType<typeof listTools>>['data'];
export type ListToolsQueryResult<
  TData = ListToolsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListToolsKey = 'ListTools';
export const UseListToolsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListToolsKey, ...(queryKey ?? [clientOptions])];
export type ListUserToolsDefaultResponse = Awaited<ReturnType<typeof listUserTools>>['data'];
export type ListUserToolsQueryResult<
  TData = ListUserToolsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListUserToolsKey = 'ListUserTools';
export const UseListUserToolsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListUserToolsKey, ...(queryKey ?? [clientOptions])];
export type ListToolsetInventoryDefaultResponse = Awaited<
  ReturnType<typeof listToolsetInventory>
>['data'];
export type ListToolsetInventoryQueryResult<
  TData = ListToolsetInventoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListToolsetInventoryKey = 'ListToolsetInventory';
export const UseListToolsetInventoryKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListToolsetInventoryKey, ...(queryKey ?? [clientOptions])];
export type ListToolsetsDefaultResponse = Awaited<ReturnType<typeof listToolsets>>['data'];
export type ListToolsetsQueryResult<
  TData = ListToolsetsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListToolsetsKey = 'ListToolsets';
export const UseListToolsetsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListToolsetsKey, ...(queryKey ?? [clientOptions])];
export type ExportToolsetDefinitionsDefaultResponse = Awaited<
  ReturnType<typeof exportToolsetDefinitions>
>['data'];
export type ExportToolsetDefinitionsQueryResult<
  TData = ExportToolsetDefinitionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useExportToolsetDefinitionsKey = 'ExportToolsetDefinitions';
export const UseExportToolsetDefinitionsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useExportToolsetDefinitionsKey, ...(queryKey ?? [clientOptions])];
export type GetToolCallResultDefaultResponse = Awaited<
  ReturnType<typeof getToolCallResult>
>['data'];
export type GetToolCallResultQueryResult<
  TData = GetToolCallResultDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetToolCallResultKey = 'GetToolCallResult';
export const UseGetToolCallResultKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetToolCallResultKey, ...(queryKey ?? [clientOptions])];
export type GetComposioConnectionStatusDefaultResponse = Awaited<
  ReturnType<typeof getComposioConnectionStatus>
>['data'];
export type GetComposioConnectionStatusQueryResult<
  TData = GetComposioConnectionStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetComposioConnectionStatusKey = 'GetComposioConnectionStatus';
export const UseGetComposioConnectionStatusKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetComposioConnectionStatusKey, ...(queryKey ?? [clientOptions])];
export type ServeStaticDefaultResponse = Awaited<ReturnType<typeof serveStatic>>['data'];
export type ServeStaticQueryResult<
  TData = ServeStaticDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useServeStaticKey = 'ServeStatic';
export const UseServeStaticKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useServeStaticKey, ...(queryKey ?? [clientOptions])];
export type GetPromptSuggestionsDefaultResponse = Awaited<
  ReturnType<typeof getPromptSuggestions>
>['data'];
export type GetPromptSuggestionsQueryResult<
  TData = GetPromptSuggestionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetPromptSuggestionsKey = 'GetPromptSuggestions';
export const UseGetPromptSuggestionsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetPromptSuggestionsKey, ...(queryKey ?? [clientOptions])];
export type GetAvailableVouchersDefaultResponse = Awaited<
  ReturnType<typeof getAvailableVouchers>
>['data'];
export type GetAvailableVouchersQueryResult<
  TData = GetAvailableVouchersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetAvailableVouchersKey = 'GetAvailableVouchers';
export const UseGetAvailableVouchersKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useGetAvailableVouchersKey, ...(queryKey ?? [clientOptions])];
export type ListUserVouchersDefaultResponse = Awaited<ReturnType<typeof listUserVouchers>>['data'];
export type ListUserVouchersQueryResult<
  TData = ListUserVouchersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListUserVouchersKey = 'ListUserVouchers';
export const UseListUserVouchersKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListUserVouchersKey, ...(queryKey ?? [clientOptions])];
export type VerifyVoucherInvitationDefaultResponse = Awaited<
  ReturnType<typeof verifyVoucherInvitation>
>['data'];
export type VerifyVoucherInvitationQueryResult<
  TData = VerifyVoucherInvitationDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useVerifyVoucherInvitationKey = 'VerifyVoucherInvitation';
export const UseVerifyVoucherInvitationKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useVerifyVoucherInvitationKey, ...(queryKey ?? [clientOptions])];
export type ListPromptSkillsDefaultResponse = Awaited<ReturnType<typeof listPromptSkills>>['data'];
export type ListPromptSkillsQueryResult<
  TData = ListPromptSkillsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useListPromptSkillsKey = 'ListPromptSkills';
export const UseListPromptSkillsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>,
) => [useListPromptSkillsKey, ...(queryKey ?? [clientOptions])];
export type GetPromptSkillDetailDefaultResponse = Awaited<
  ReturnType<typeof getPromptSkillDetail>
>['data'];
export type GetPromptSkillDetailQueryResult<
  TData = GetPromptSkillDetailDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGetPromptSkillDetailKey = 'GetPromptSkillDetail';
export const UseGetPromptSkillDetailKeyFn = (
  clientOptions: Options<unknown, true>,
  queryKey?: Array<unknown>,
) => [useGetPromptSkillDetailKey, ...(queryKey ?? [clientOptions])];
export type RecognizeSocialAccountsMutationResult = Awaited<
  ReturnType<typeof recognizeSocialAccounts>
>;
export const useRecognizeSocialAccountsKey = 'RecognizeSocialAccounts';
export const UseRecognizeSocialAccountsKeyFn = (mutationKey?: Array<unknown>) => [
  useRecognizeSocialAccountsKey,
  ...(mutationKey ?? []),
];
export type ManualBindSocialAccountsMutationResult = Awaited<
  ReturnType<typeof manualBindSocialAccounts>
>;
export const useManualBindSocialAccountsKey = 'ManualBindSocialAccounts';
export const UseManualBindSocialAccountsKeyFn = (mutationKey?: Array<unknown>) => [
  useManualBindSocialAccountsKey,
  ...(mutationKey ?? []),
];
export type StartSocialAccountInteractiveLoginMutationResult = Awaited<
  ReturnType<typeof startSocialAccountInteractiveLogin>
>;
export const useStartSocialAccountInteractiveLoginKey = 'StartSocialAccountInteractiveLogin';
export const UseStartSocialAccountInteractiveLoginKeyFn = (mutationKey?: Array<unknown>) => [
  useStartSocialAccountInteractiveLoginKey,
  ...(mutationKey ?? []),
];
export type CompleteSocialAccountInteractiveLoginMutationResult = Awaited<
  ReturnType<typeof completeSocialAccountInteractiveLogin>
>;
export const useCompleteSocialAccountInteractiveLoginKey = 'CompleteSocialAccountInteractiveLogin';
export const UseCompleteSocialAccountInteractiveLoginKeyFn = (mutationKey?: Array<unknown>) => [
  useCompleteSocialAccountInteractiveLoginKey,
  ...(mutationKey ?? []),
];
export type SaveSocialAccountLoginCookiesMutationResult = Awaited<
  ReturnType<typeof saveSocialAccountLoginCookies>
>;
export const useSaveSocialAccountLoginCookiesKey = 'SaveSocialAccountLoginCookies';
export const UseSaveSocialAccountLoginCookiesKeyFn = (mutationKey?: Array<unknown>) => [
  useSaveSocialAccountLoginCookiesKey,
  ...(mutationKey ?? []),
];
export type CloseSocialAccountLoginBrowserMutationResult = Awaited<
  ReturnType<typeof closeSocialAccountLoginBrowser>
>;
export const useCloseSocialAccountLoginBrowserKey = 'CloseSocialAccountLoginBrowser';
export const UseCloseSocialAccountLoginBrowserKeyFn = (mutationKey?: Array<unknown>) => [
  useCloseSocialAccountLoginBrowserKey,
  ...(mutationKey ?? []),
];
export type StartSocialAccountLoginBatchMutationResult = Awaited<
  ReturnType<typeof startSocialAccountLoginBatch>
>;
export const useStartSocialAccountLoginBatchKey = 'StartSocialAccountLoginBatch';
export const UseStartSocialAccountLoginBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useStartSocialAccountLoginBatchKey,
  ...(mutationKey ?? []),
];
export type ContinueSocialAccountLoginBatchMutationResult = Awaited<
  ReturnType<typeof continueSocialAccountLoginBatch>
>;
export const useContinueSocialAccountLoginBatchKey = 'ContinueSocialAccountLoginBatch';
export const UseContinueSocialAccountLoginBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useContinueSocialAccountLoginBatchKey,
  ...(mutationKey ?? []),
];
export type StopSocialAccountLoginBatchMutationResult = Awaited<
  ReturnType<typeof stopSocialAccountLoginBatch>
>;
export const useStopSocialAccountLoginBatchKey = 'StopSocialAccountLoginBatch';
export const UseStopSocialAccountLoginBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useStopSocialAccountLoginBatchKey,
  ...(mutationKey ?? []),
];
export type CancelOneSocialAccountLoginBatchMutationResult = Awaited<
  ReturnType<typeof cancelOneSocialAccountLoginBatch>
>;
export const useCancelOneSocialAccountLoginBatchKey = 'CancelOneSocialAccountLoginBatch';
export const UseCancelOneSocialAccountLoginBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useCancelOneSocialAccountLoginBatchKey,
  ...(mutationKey ?? []),
];
export type SaveOneSocialAccountLoginBatchMutationResult = Awaited<
  ReturnType<typeof saveOneSocialAccountLoginBatch>
>;
export const useSaveOneSocialAccountLoginBatchKey = 'SaveOneSocialAccountLoginBatch';
export const UseSaveOneSocialAccountLoginBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useSaveOneSocialAccountLoginBatchKey,
  ...(mutationKey ?? []),
];
export type CreateWorkflowSkillMutationResult = Awaited<ReturnType<typeof createWorkflowSkill>>;
export const useCreateWorkflowSkillKey = 'CreateWorkflowSkill';
export const UseCreateWorkflowSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateWorkflowSkillKey,
  ...(mutationKey ?? []),
];
export type DeleteWorkflowSkillMutationResult = Awaited<ReturnType<typeof deleteWorkflowSkill>>;
export const useDeleteWorkflowSkillKey = 'DeleteWorkflowSkill';
export const UseDeleteWorkflowSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteWorkflowSkillKey,
  ...(mutationKey ?? []),
];
export type InvokeWorkflowSkillMutationResult = Awaited<ReturnType<typeof invokeWorkflowSkill>>;
export const useInvokeWorkflowSkillKey = 'InvokeWorkflowSkill';
export const UseInvokeWorkflowSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useInvokeWorkflowSkillKey,
  ...(mutationKey ?? []),
];
export type CreateSocialAccountMutationResult = Awaited<ReturnType<typeof createSocialAccount>>;
export const useCreateSocialAccountKey = 'CreateSocialAccount';
export const UseCreateSocialAccountKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateSocialAccountKey,
  ...(mutationKey ?? []),
];
export type BatchCreateSocialAccountsMutationResult = Awaited<
  ReturnType<typeof batchCreateSocialAccounts>
>;
export const useBatchCreateSocialAccountsKey = 'BatchCreateSocialAccounts';
export const UseBatchCreateSocialAccountsKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchCreateSocialAccountsKey,
  ...(mutationKey ?? []),
];
export type CreateSocialAccountAutoBindingBatchMutationResult = Awaited<
  ReturnType<typeof createSocialAccountAutoBindingBatch>
>;
export const useCreateSocialAccountAutoBindingBatchKey = 'CreateSocialAccountAutoBindingBatch';
export const UseCreateSocialAccountAutoBindingBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateSocialAccountAutoBindingBatchKey,
  ...(mutationKey ?? []),
];
export type StartSocialAccountReloginBatchMutationResult = Awaited<
  ReturnType<typeof startSocialAccountReloginBatch>
>;
export const useStartSocialAccountReloginBatchKey = 'StartSocialAccountReloginBatch';
export const UseStartSocialAccountReloginBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useStartSocialAccountReloginBatchKey,
  ...(mutationKey ?? []),
];
export type UpdateSocialAccountCredentialMutationResult = Awaited<
  ReturnType<typeof updateSocialAccountCredential>
>;
export const useUpdateSocialAccountCredentialKey = 'UpdateSocialAccountCredential';
export const UseUpdateSocialAccountCredentialKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateSocialAccountCredentialKey,
  ...(mutationKey ?? []),
];
export type UpdateSocialAccountProfileMutationResult = Awaited<
  ReturnType<typeof updateSocialAccountProfile>
>;
export const useUpdateSocialAccountProfileKey = 'UpdateSocialAccountProfile';
export const UseUpdateSocialAccountProfileKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateSocialAccountProfileKey,
  ...(mutationKey ?? []),
];
export type UpdateSocialAccountRemarkMutationResult = Awaited<
  ReturnType<typeof updateSocialAccountRemark>
>;
export const useUpdateSocialAccountRemarkKey = 'UpdateSocialAccountRemark';
export const UseUpdateSocialAccountRemarkKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateSocialAccountRemarkKey,
  ...(mutationKey ?? []),
];
export type SaveSocialBrowserStateMutationResult = Awaited<
  ReturnType<typeof saveSocialBrowserState>
>;
export const useSaveSocialBrowserStateKey = 'SaveSocialBrowserState';
export const UseSaveSocialBrowserStateKeyFn = (mutationKey?: Array<unknown>) => [
  useSaveSocialBrowserStateKey,
  ...(mutationKey ?? []),
];
export type ImportSocialBrowserStateMutationResult = Awaited<
  ReturnType<typeof importSocialBrowserState>
>;
export const useImportSocialBrowserStateKey = 'ImportSocialBrowserState';
export const UseImportSocialBrowserStateKeyFn = (mutationKey?: Array<unknown>) => [
  useImportSocialBrowserStateKey,
  ...(mutationKey ?? []),
];
export type ImportSocialBrowserStateFileMutationResult = Awaited<
  ReturnType<typeof importSocialBrowserStateFile>
>;
export const useImportSocialBrowserStateFileKey = 'ImportSocialBrowserStateFile';
export const UseImportSocialBrowserStateFileKeyFn = (mutationKey?: Array<unknown>) => [
  useImportSocialBrowserStateFileKey,
  ...(mutationKey ?? []),
];
export type IssueSocialBrowserStateExportTicketMutationResult = Awaited<
  ReturnType<typeof issueSocialBrowserStateExportTicket>
>;
export const useIssueSocialBrowserStateExportTicketKey = 'IssueSocialBrowserStateExportTicket';
export const UseIssueSocialBrowserStateExportTicketKeyFn = (mutationKey?: Array<unknown>) => [
  useIssueSocialBrowserStateExportTicketKey,
  ...(mutationKey ?? []),
];
export type UpdateSocialAccountStatusMutationResult = Awaited<
  ReturnType<typeof updateSocialAccountStatus>
>;
export const useUpdateSocialAccountStatusKey = 'UpdateSocialAccountStatus';
export const UseUpdateSocialAccountStatusKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateSocialAccountStatusKey,
  ...(mutationKey ?? []),
];
export type CreateSocialAccountCategoryMutationResult = Awaited<
  ReturnType<typeof createSocialAccountCategory>
>;
export const useCreateSocialAccountCategoryKey = 'CreateSocialAccountCategory';
export const UseCreateSocialAccountCategoryKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateSocialAccountCategoryKey,
  ...(mutationKey ?? []),
];
export type UpdateSocialAccountCategoryMutationResult = Awaited<
  ReturnType<typeof updateSocialAccountCategory>
>;
export const useUpdateSocialAccountCategoryKey = 'UpdateSocialAccountCategory';
export const UseUpdateSocialAccountCategoryKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateSocialAccountCategoryKey,
  ...(mutationKey ?? []),
];
export type BindSocialAccountToCategoryMutationResult = Awaited<
  ReturnType<typeof bindSocialAccountToCategory>
>;
export const useBindSocialAccountToCategoryKey = 'BindSocialAccountToCategory';
export const UseBindSocialAccountToCategoryKeyFn = (mutationKey?: Array<unknown>) => [
  useBindSocialAccountToCategoryKey,
  ...(mutationKey ?? []),
];
export type BatchBindSocialAccountsToCategoryMutationResult = Awaited<
  ReturnType<typeof batchBindSocialAccountsToCategory>
>;
export const useBatchBindSocialAccountsToCategoryKey = 'BatchBindSocialAccountsToCategory';
export const UseBatchBindSocialAccountsToCategoryKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchBindSocialAccountsToCategoryKey,
  ...(mutationKey ?? []),
];
export type BatchUnbindSocialAccountsFromCategoryMutationResult = Awaited<
  ReturnType<typeof batchUnbindSocialAccountsFromCategory>
>;
export const useBatchUnbindSocialAccountsFromCategoryKey = 'BatchUnbindSocialAccountsFromCategory';
export const UseBatchUnbindSocialAccountsFromCategoryKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchUnbindSocialAccountsFromCategoryKey,
  ...(mutationKey ?? []),
];
export type MoveSocialAccountsCategoryMutationResult = Awaited<
  ReturnType<typeof moveSocialAccountsCategory>
>;
export const useMoveSocialAccountsCategoryKey = 'MoveSocialAccountsCategory';
export const UseMoveSocialAccountsCategoryKeyFn = (mutationKey?: Array<unknown>) => [
  useMoveSocialAccountsCategoryKey,
  ...(mutationKey ?? []),
];
export type CreateVideoEditProjectMutationResult = Awaited<
  ReturnType<typeof createVideoEditProject>
>;
export const useCreateVideoEditProjectKey = 'CreateVideoEditProject';
export const UseCreateVideoEditProjectKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateVideoEditProjectKey,
  ...(mutationKey ?? []),
];
export type ConfirmVideoEditNarrativeMutationResult = Awaited<
  ReturnType<typeof confirmVideoEditNarrative>
>;
export const useConfirmVideoEditNarrativeKey = 'ConfirmVideoEditNarrative';
export const UseConfirmVideoEditNarrativeKeyFn = (mutationKey?: Array<unknown>) => [
  useConfirmVideoEditNarrativeKey,
  ...(mutationKey ?? []),
];
export type RegenerateVideoEditNarrativeMutationResult = Awaited<
  ReturnType<typeof regenerateVideoEditNarrative>
>;
export const useRegenerateVideoEditNarrativeKey = 'RegenerateVideoEditNarrative';
export const UseRegenerateVideoEditNarrativeKeyFn = (mutationKey?: Array<unknown>) => [
  useRegenerateVideoEditNarrativeKey,
  ...(mutationKey ?? []),
];
export type AttachVideoEditProjectAssetsMutationResult = Awaited<
  ReturnType<typeof attachVideoEditProjectAssets>
>;
export const useAttachVideoEditProjectAssetsKey = 'AttachVideoEditProjectAssets';
export const UseAttachVideoEditProjectAssetsKeyFn = (mutationKey?: Array<unknown>) => [
  useAttachVideoEditProjectAssetsKey,
  ...(mutationKey ?? []),
];
export type CompleteVideoManualEditMutationResult = Awaited<
  ReturnType<typeof completeVideoManualEdit>
>;
export const useCompleteVideoManualEditKey = 'CompleteVideoManualEdit';
export const UseCompleteVideoManualEditKeyFn = (mutationKey?: Array<unknown>) => [
  useCompleteVideoManualEditKey,
  ...(mutationKey ?? []),
];
export type EnsureProductionStudioWorkspaceMutationResult = Awaited<
  ReturnType<typeof ensureProductionStudioWorkspace>
>;
export const useEnsureProductionStudioWorkspaceKey = 'EnsureProductionStudioWorkspace';
export const UseEnsureProductionStudioWorkspaceKeyFn = (mutationKey?: Array<unknown>) => [
  useEnsureProductionStudioWorkspaceKey,
  ...(mutationKey ?? []),
];
export type ImportProductionStudioClientPackMutationResult = Awaited<
  ReturnType<typeof importProductionStudioClientPack>
>;
export const useImportProductionStudioClientPackKey = 'ImportProductionStudioClientPack';
export const UseImportProductionStudioClientPackKeyFn = (mutationKey?: Array<unknown>) => [
  useImportProductionStudioClientPackKey,
  ...(mutationKey ?? []),
];
export type CreateProductionStudioBatchMutationResult = Awaited<
  ReturnType<typeof createProductionStudioBatch>
>;
export const useCreateProductionStudioBatchKey = 'CreateProductionStudioBatch';
export const UseCreateProductionStudioBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateProductionStudioBatchKey,
  ...(mutationKey ?? []),
];
export type CopyProductionStudioBatchMutationResult = Awaited<
  ReturnType<typeof copyProductionStudioBatch>
>;
export const useCopyProductionStudioBatchKey = 'CopyProductionStudioBatch';
export const UseCopyProductionStudioBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useCopyProductionStudioBatchKey,
  ...(mutationKey ?? []),
];
export type SaveProductionStudioScriptMutationResult = Awaited<
  ReturnType<typeof saveProductionStudioScript>
>;
export const useSaveProductionStudioScriptKey = 'SaveProductionStudioScript';
export const UseSaveProductionStudioScriptKeyFn = (mutationKey?: Array<unknown>) => [
  useSaveProductionStudioScriptKey,
  ...(mutationKey ?? []),
];
export type ImportProductionStudioScriptsMutationResult = Awaited<
  ReturnType<typeof importProductionStudioScripts>
>;
export const useImportProductionStudioScriptsKey = 'ImportProductionStudioScripts';
export const UseImportProductionStudioScriptsKeyFn = (mutationKey?: Array<unknown>) => [
  useImportProductionStudioScriptsKey,
  ...(mutationKey ?? []),
];
export type RegenerateProductionStudioScriptsMutationResult = Awaited<
  ReturnType<typeof regenerateProductionStudioScripts>
>;
export const useRegenerateProductionStudioScriptsKey = 'RegenerateProductionStudioScripts';
export const UseRegenerateProductionStudioScriptsKeyFn = (mutationKey?: Array<unknown>) => [
  useRegenerateProductionStudioScriptsKey,
  ...(mutationKey ?? []),
];
export type ConfirmProductionStudioScriptMutationResult = Awaited<
  ReturnType<typeof confirmProductionStudioScript>
>;
export const useConfirmProductionStudioScriptKey = 'ConfirmProductionStudioScript';
export const UseConfirmProductionStudioScriptKeyFn = (mutationKey?: Array<unknown>) => [
  useConfirmProductionStudioScriptKey,
  ...(mutationKey ?? []),
];
export type ConfirmAllProductionStudioScriptsMutationResult = Awaited<
  ReturnType<typeof confirmAllProductionStudioScripts>
>;
export const useConfirmAllProductionStudioScriptsKey = 'ConfirmAllProductionStudioScripts';
export const UseConfirmAllProductionStudioScriptsKeyFn = (mutationKey?: Array<unknown>) => [
  useConfirmAllProductionStudioScriptsKey,
  ...(mutationKey ?? []),
];
export type StartProductionStudioBatchMutationResult = Awaited<
  ReturnType<typeof startProductionStudioBatch>
>;
export const useStartProductionStudioBatchKey = 'StartProductionStudioBatch';
export const UseStartProductionStudioBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useStartProductionStudioBatchKey,
  ...(mutationKey ?? []),
];
export type PauseProductionStudioBatchMutationResult = Awaited<
  ReturnType<typeof pauseProductionStudioBatch>
>;
export const usePauseProductionStudioBatchKey = 'PauseProductionStudioBatch';
export const UsePauseProductionStudioBatchKeyFn = (mutationKey?: Array<unknown>) => [
  usePauseProductionStudioBatchKey,
  ...(mutationKey ?? []),
];
export type CancelProductionStudioBatchMutationResult = Awaited<
  ReturnType<typeof cancelProductionStudioBatch>
>;
export const useCancelProductionStudioBatchKey = 'CancelProductionStudioBatch';
export const UseCancelProductionStudioBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useCancelProductionStudioBatchKey,
  ...(mutationKey ?? []),
];
export type ReviewProductionStudioOutputMutationResult = Awaited<
  ReturnType<typeof reviewProductionStudioOutput>
>;
export const useReviewProductionStudioOutputKey = 'ReviewProductionStudioOutput';
export const UseReviewProductionStudioOutputKeyFn = (mutationKey?: Array<unknown>) => [
  useReviewProductionStudioOutputKey,
  ...(mutationKey ?? []),
];
export type CreateSocialBrowserSessionMutationResult = Awaited<
  ReturnType<typeof createSocialBrowserSession>
>;
export const useCreateSocialBrowserSessionKey = 'CreateSocialBrowserSession';
export const UseCreateSocialBrowserSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateSocialBrowserSessionKey,
  ...(mutationKey ?? []),
];
export type IssueSocialBrowserViewerTicketMutationResult = Awaited<
  ReturnType<typeof issueSocialBrowserViewerTicket>
>;
export const useIssueSocialBrowserViewerTicketKey = 'IssueSocialBrowserViewerTicket';
export const UseIssueSocialBrowserViewerTicketKeyFn = (mutationKey?: Array<unknown>) => [
  useIssueSocialBrowserViewerTicketKey,
  ...(mutationKey ?? []),
];
export type OpenSocialBrowserViewerConnectionMutationResult = Awaited<
  ReturnType<typeof openSocialBrowserViewerConnection>
>;
export const useOpenSocialBrowserViewerConnectionKey = 'OpenSocialBrowserViewerConnection';
export const UseOpenSocialBrowserViewerConnectionKeyFn = (mutationKey?: Array<unknown>) => [
  useOpenSocialBrowserViewerConnectionKey,
  ...(mutationKey ?? []),
];
export type SetSocialBrowserSessionAutomationMutationResult = Awaited<
  ReturnType<typeof setSocialBrowserSessionAutomation>
>;
export const useSetSocialBrowserSessionAutomationKey = 'SetSocialBrowserSessionAutomation';
export const UseSetSocialBrowserSessionAutomationKeyFn = (mutationKey?: Array<unknown>) => [
  useSetSocialBrowserSessionAutomationKey,
  ...(mutationKey ?? []),
];
export type CompleteSocialBrowserSessionMutationResult = Awaited<
  ReturnType<typeof completeSocialBrowserSession>
>;
export const useCompleteSocialBrowserSessionKey = 'CompleteSocialBrowserSession';
export const UseCompleteSocialBrowserSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useCompleteSocialBrowserSessionKey,
  ...(mutationKey ?? []),
];
export type CancelSocialBrowserSessionMutationResult = Awaited<
  ReturnType<typeof cancelSocialBrowserSession>
>;
export const useCancelSocialBrowserSessionKey = 'CancelSocialBrowserSession';
export const UseCancelSocialBrowserSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useCancelSocialBrowserSessionKey,
  ...(mutationKey ?? []),
];
export type ExtendSocialBrowserSessionMutationResult = Awaited<
  ReturnType<typeof extendSocialBrowserSession>
>;
export const useExtendSocialBrowserSessionKey = 'ExtendSocialBrowserSession';
export const UseExtendSocialBrowserSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useExtendSocialBrowserSessionKey,
  ...(mutationKey ?? []),
];
export type CreateSocialBrowserSessionBatchMutationResult = Awaited<
  ReturnType<typeof createSocialBrowserSessionBatch>
>;
export const useCreateSocialBrowserSessionBatchKey = 'CreateSocialBrowserSessionBatch';
export const UseCreateSocialBrowserSessionBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateSocialBrowserSessionBatchKey,
  ...(mutationKey ?? []),
];
export type CancelSocialBrowserSessionBatchMutationResult = Awaited<
  ReturnType<typeof cancelSocialBrowserSessionBatch>
>;
export const useCancelSocialBrowserSessionBatchKey = 'CancelSocialBrowserSessionBatch';
export const UseCancelSocialBrowserSessionBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useCancelSocialBrowserSessionBatchKey,
  ...(mutationKey ?? []),
];
export type CancelSocialBrowserSessionBatchItemMutationResult = Awaited<
  ReturnType<typeof cancelSocialBrowserSessionBatchItem>
>;
export const useCancelSocialBrowserSessionBatchItemKey = 'CancelSocialBrowserSessionBatchItem';
export const UseCancelSocialBrowserSessionBatchItemKeyFn = (mutationKey?: Array<unknown>) => [
  useCancelSocialBrowserSessionBatchItemKey,
  ...(mutationKey ?? []),
];
export type CreateMediaLibraryEntryMutationResult = Awaited<
  ReturnType<typeof createMediaLibraryEntry>
>;
export const useCreateMediaLibraryEntryKey = 'CreateMediaLibraryEntry';
export const UseCreateMediaLibraryEntryKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateMediaLibraryEntryKey,
  ...(mutationKey ?? []),
];
export type BatchDeleteMediaLibraryEntriesMutationResult = Awaited<
  ReturnType<typeof batchDeleteMediaLibraryEntries>
>;
export const useBatchDeleteMediaLibraryEntriesKey = 'BatchDeleteMediaLibraryEntries';
export const UseBatchDeleteMediaLibraryEntriesKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchDeleteMediaLibraryEntriesKey,
  ...(mutationKey ?? []),
];
export type InitializeMediaLibraryUploadMutationResult = Awaited<
  ReturnType<typeof initializeMediaLibraryUpload>
>;
export const useInitializeMediaLibraryUploadKey = 'InitializeMediaLibraryUpload';
export const UseInitializeMediaLibraryUploadKeyFn = (mutationKey?: Array<unknown>) => [
  useInitializeMediaLibraryUploadKey,
  ...(mutationKey ?? []),
];
export type SignMediaLibraryUploadPartsMutationResult = Awaited<
  ReturnType<typeof signMediaLibraryUploadParts>
>;
export const useSignMediaLibraryUploadPartsKey = 'SignMediaLibraryUploadParts';
export const UseSignMediaLibraryUploadPartsKeyFn = (mutationKey?: Array<unknown>) => [
  useSignMediaLibraryUploadPartsKey,
  ...(mutationKey ?? []),
];
export type CompleteMediaLibraryUploadMutationResult = Awaited<
  ReturnType<typeof completeMediaLibraryUpload>
>;
export const useCompleteMediaLibraryUploadKey = 'CompleteMediaLibraryUpload';
export const UseCompleteMediaLibraryUploadKeyFn = (mutationKey?: Array<unknown>) => [
  useCompleteMediaLibraryUploadKey,
  ...(mutationKey ?? []),
];
export type AbortMediaLibraryUploadMutationResult = Awaited<
  ReturnType<typeof abortMediaLibraryUpload>
>;
export const useAbortMediaLibraryUploadKey = 'AbortMediaLibraryUpload';
export const UseAbortMediaLibraryUploadKeyFn = (mutationKey?: Array<unknown>) => [
  useAbortMediaLibraryUploadKey,
  ...(mutationKey ?? []),
];
export type CreateMediaLibraryDownloadTaskMutationResult = Awaited<
  ReturnType<typeof createMediaLibraryDownloadTask>
>;
export const useCreateMediaLibraryDownloadTaskKey = 'CreateMediaLibraryDownloadTask';
export const UseCreateMediaLibraryDownloadTaskKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateMediaLibraryDownloadTaskKey,
  ...(mutationKey ?? []),
];
export type ImportCanvasMaterialsToLibraryMutationResult = Awaited<
  ReturnType<typeof importCanvasMaterialsToLibrary>
>;
export const useImportCanvasMaterialsToLibraryKey = 'ImportCanvasMaterialsToLibrary';
export const UseImportCanvasMaterialsToLibraryKeyFn = (mutationKey?: Array<unknown>) => [
  useImportCanvasMaterialsToLibraryKey,
  ...(mutationKey ?? []),
];
export type ImportCanvasMaterialsFromLibraryMutationResult = Awaited<
  ReturnType<typeof importCanvasMaterialsFromLibrary>
>;
export const useImportCanvasMaterialsFromLibraryKey = 'ImportCanvasMaterialsFromLibrary';
export const UseImportCanvasMaterialsFromLibraryKeyFn = (mutationKey?: Array<unknown>) => [
  useImportCanvasMaterialsFromLibraryKey,
  ...(mutationKey ?? []),
];
export type CreateCanvasMaterialDownloadTaskMutationResult = Awaited<
  ReturnType<typeof createCanvasMaterialDownloadTask>
>;
export const useCreateCanvasMaterialDownloadTaskKey = 'CreateCanvasMaterialDownloadTask';
export const UseCreateCanvasMaterialDownloadTaskKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateCanvasMaterialDownloadTaskKey,
  ...(mutationKey ?? []),
];
export type ExtractVariablesMutationResult = Awaited<ReturnType<typeof extractVariables>>;
export const useExtractVariablesKey = 'ExtractVariables';
export const UseExtractVariablesKeyFn = (mutationKey?: Array<unknown>) => [
  useExtractVariablesKey,
  ...(mutationKey ?? []),
];
export type GenerateAppTemplateMutationResult = Awaited<ReturnType<typeof generateAppTemplate>>;
export const useGenerateAppTemplateKey = 'GenerateAppTemplate';
export const UseGenerateAppTemplateKeyFn = (mutationKey?: Array<unknown>) => [
  useGenerateAppTemplateKey,
  ...(mutationKey ?? []),
];
export type CreateMcpServerMutationResult = Awaited<ReturnType<typeof createMcpServer>>;
export const useCreateMcpServerKey = 'CreateMcpServer';
export const UseCreateMcpServerKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateMcpServerKey,
  ...(mutationKey ?? []),
];
export type UpdateMcpServerMutationResult = Awaited<ReturnType<typeof updateMcpServer>>;
export const useUpdateMcpServerKey = 'UpdateMcpServer';
export const UseUpdateMcpServerKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateMcpServerKey,
  ...(mutationKey ?? []),
];
export type DeleteMcpServerMutationResult = Awaited<ReturnType<typeof deleteMcpServer>>;
export const useDeleteMcpServerKey = 'DeleteMcpServer';
export const UseDeleteMcpServerKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteMcpServerKey,
  ...(mutationKey ?? []),
];
export type ValidateMcpServerMutationResult = Awaited<ReturnType<typeof validateMcpServer>>;
export const useValidateMcpServerKey = 'ValidateMcpServer';
export const UseValidateMcpServerKeyFn = (mutationKey?: Array<unknown>) => [
  useValidateMcpServerKey,
  ...(mutationKey ?? []),
];
export type SharePageMutationResult = Awaited<ReturnType<typeof sharePage>>;
export const useSharePageKey = 'SharePage';
export const UseSharePageKeyFn = (mutationKey?: Array<unknown>) => [
  useSharePageKey,
  ...(mutationKey ?? []),
];
export type AddNodesToCanvasPageMutationResult = Awaited<ReturnType<typeof addNodesToCanvasPage>>;
export const useAddNodesToCanvasPageKey = 'AddNodesToCanvasPage';
export const UseAddNodesToCanvasPageKeyFn = (mutationKey?: Array<unknown>) => [
  useAddNodesToCanvasPageKey,
  ...(mutationKey ?? []),
];
export type RefreshTokenMutationResult = Awaited<ReturnType<typeof refreshToken>>;
export const useRefreshTokenKey = 'RefreshToken';
export const UseRefreshTokenKeyFn = (mutationKey?: Array<unknown>) => [
  useRefreshTokenKey,
  ...(mutationKey ?? []),
];
export type EmailSignupMutationResult = Awaited<ReturnType<typeof emailSignup>>;
export const useEmailSignupKey = 'EmailSignup';
export const UseEmailSignupKeyFn = (mutationKey?: Array<unknown>) => [
  useEmailSignupKey,
  ...(mutationKey ?? []),
];
export type EmailLoginMutationResult = Awaited<ReturnType<typeof emailLogin>>;
export const useEmailLoginKey = 'EmailLogin';
export const UseEmailLoginKeyFn = (mutationKey?: Array<unknown>) => [
  useEmailLoginKey,
  ...(mutationKey ?? []),
];
export type CreateVerificationMutationResult = Awaited<ReturnType<typeof createVerification>>;
export const useCreateVerificationKey = 'CreateVerification';
export const UseCreateVerificationKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateVerificationKey,
  ...(mutationKey ?? []),
];
export type ResendVerificationMutationResult = Awaited<ReturnType<typeof resendVerification>>;
export const useResendVerificationKey = 'ResendVerification';
export const UseResendVerificationKeyFn = (mutationKey?: Array<unknown>) => [
  useResendVerificationKey,
  ...(mutationKey ?? []),
];
export type CheckVerificationMutationResult = Awaited<ReturnType<typeof checkVerification>>;
export const useCheckVerificationKey = 'CheckVerification';
export const UseCheckVerificationKeyFn = (mutationKey?: Array<unknown>) => [
  useCheckVerificationKey,
  ...(mutationKey ?? []),
];
export type LogoutMutationResult = Awaited<ReturnType<typeof logout>>;
export const useLogoutKey = 'Logout';
export const UseLogoutKeyFn = (mutationKey?: Array<unknown>) => [
  useLogoutKey,
  ...(mutationKey ?? []),
];
export type ImportCanvasMutationResult = Awaited<ReturnType<typeof importCanvas>>;
export const useImportCanvasKey = 'ImportCanvas';
export const UseImportCanvasKeyFn = (mutationKey?: Array<unknown>) => [
  useImportCanvasKey,
  ...(mutationKey ?? []),
];
export type CreateCanvasMutationResult = Awaited<ReturnType<typeof createCanvas>>;
export const useCreateCanvasKey = 'CreateCanvas';
export const UseCreateCanvasKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateCanvasKey,
  ...(mutationKey ?? []),
];
export type DuplicateCanvasMutationResult = Awaited<ReturnType<typeof duplicateCanvas>>;
export const useDuplicateCanvasKey = 'DuplicateCanvas';
export const UseDuplicateCanvasKeyFn = (mutationKey?: Array<unknown>) => [
  useDuplicateCanvasKey,
  ...(mutationKey ?? []),
];
export type UpdateCanvasMutationResult = Awaited<ReturnType<typeof updateCanvas>>;
export const useUpdateCanvasKey = 'UpdateCanvas';
export const UseUpdateCanvasKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateCanvasKey,
  ...(mutationKey ?? []),
];
export type DeleteCanvasMutationResult = Awaited<ReturnType<typeof deleteCanvas>>;
export const useDeleteCanvasKey = 'DeleteCanvas';
export const UseDeleteCanvasKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteCanvasKey,
  ...(mutationKey ?? []),
];
export type AutoNameCanvasMutationResult = Awaited<ReturnType<typeof autoNameCanvas>>;
export const useAutoNameCanvasKey = 'AutoNameCanvas';
export const UseAutoNameCanvasKeyFn = (mutationKey?: Array<unknown>) => [
  useAutoNameCanvasKey,
  ...(mutationKey ?? []),
];
export type SetCanvasStateMutationResult = Awaited<ReturnType<typeof setCanvasState>>;
export const useSetCanvasStateKey = 'SetCanvasState';
export const UseSetCanvasStateKeyFn = (mutationKey?: Array<unknown>) => [
  useSetCanvasStateKey,
  ...(mutationKey ?? []),
];
export type SyncCanvasStateMutationResult = Awaited<ReturnType<typeof syncCanvasState>>;
export const useSyncCanvasStateKey = 'SyncCanvasState';
export const UseSyncCanvasStateKeyFn = (mutationKey?: Array<unknown>) => [
  useSyncCanvasStateKey,
  ...(mutationKey ?? []),
];
export type CreateCanvasVersionMutationResult = Awaited<ReturnType<typeof createCanvasVersion>>;
export const useCreateCanvasVersionKey = 'CreateCanvasVersion';
export const UseCreateCanvasVersionKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateCanvasVersionKey,
  ...(mutationKey ?? []),
];
export type UpdateWorkflowVariablesMutationResult = Awaited<
  ReturnType<typeof updateWorkflowVariables>
>;
export const useUpdateWorkflowVariablesKey = 'UpdateWorkflowVariables';
export const UseUpdateWorkflowVariablesKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateWorkflowVariablesKey,
  ...(mutationKey ?? []),
];
export type CreateDriveFileMutationResult = Awaited<ReturnType<typeof createDriveFile>>;
export const useCreateDriveFileKey = 'CreateDriveFile';
export const UseCreateDriveFileKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateDriveFileKey,
  ...(mutationKey ?? []),
];
export type BatchCreateDriveFilesMutationResult = Awaited<ReturnType<typeof batchCreateDriveFiles>>;
export const useBatchCreateDriveFilesKey = 'BatchCreateDriveFiles';
export const UseBatchCreateDriveFilesKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchCreateDriveFilesKey,
  ...(mutationKey ?? []),
];
export type UpdateDriveFileMutationResult = Awaited<ReturnType<typeof updateDriveFile>>;
export const useUpdateDriveFileKey = 'UpdateDriveFile';
export const UseUpdateDriveFileKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateDriveFileKey,
  ...(mutationKey ?? []),
];
export type DeleteDriveFileMutationResult = Awaited<ReturnType<typeof deleteDriveFile>>;
export const useDeleteDriveFileKey = 'DeleteDriveFile';
export const UseDeleteDriveFileKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteDriveFileKey,
  ...(mutationKey ?? []),
];
export type CreateCanvasTemplateMutationResult = Awaited<ReturnType<typeof createCanvasTemplate>>;
export const useCreateCanvasTemplateKey = 'CreateCanvasTemplate';
export const UseCreateCanvasTemplateKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateCanvasTemplateKey,
  ...(mutationKey ?? []),
];
export type UpdateCanvasTemplateMutationResult = Awaited<ReturnType<typeof updateCanvasTemplate>>;
export const useUpdateCanvasTemplateKey = 'UpdateCanvasTemplate';
export const UseUpdateCanvasTemplateKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateCanvasTemplateKey,
  ...(mutationKey ?? []),
];
export type UpdateResourceMutationResult = Awaited<ReturnType<typeof updateResource>>;
export const useUpdateResourceKey = 'UpdateResource';
export const UseUpdateResourceKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateResourceKey,
  ...(mutationKey ?? []),
];
export type CreateResourceMutationResult = Awaited<ReturnType<typeof createResource>>;
export const useCreateResourceKey = 'CreateResource';
export const UseCreateResourceKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateResourceKey,
  ...(mutationKey ?? []),
];
export type CreateResourceWithFileMutationResult = Awaited<
  ReturnType<typeof createResourceWithFile>
>;
export const useCreateResourceWithFileKey = 'CreateResourceWithFile';
export const UseCreateResourceWithFileKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateResourceWithFileKey,
  ...(mutationKey ?? []),
];
export type BatchCreateResourceMutationResult = Awaited<ReturnType<typeof batchCreateResource>>;
export const useBatchCreateResourceKey = 'BatchCreateResource';
export const UseBatchCreateResourceKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchCreateResourceKey,
  ...(mutationKey ?? []),
];
export type ReindexResourceMutationResult = Awaited<ReturnType<typeof reindexResource>>;
export const useReindexResourceKey = 'ReindexResource';
export const UseReindexResourceKeyFn = (mutationKey?: Array<unknown>) => [
  useReindexResourceKey,
  ...(mutationKey ?? []),
];
export type DeleteResourceMutationResult = Awaited<ReturnType<typeof deleteResource>>;
export const useDeleteResourceKey = 'DeleteResource';
export const UseDeleteResourceKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteResourceKey,
  ...(mutationKey ?? []),
];
export type StartExportJobMutationResult = Awaited<ReturnType<typeof startExportJob>>;
export const useStartExportJobKey = 'StartExportJob';
export const UseStartExportJobKeyFn = (mutationKey?: Array<unknown>) => [
  useStartExportJobKey,
  ...(mutationKey ?? []),
];
export type UpdateDocumentMutationResult = Awaited<ReturnType<typeof updateDocument>>;
export const useUpdateDocumentKey = 'UpdateDocument';
export const UseUpdateDocumentKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateDocumentKey,
  ...(mutationKey ?? []),
];
export type CreateDocumentMutationResult = Awaited<ReturnType<typeof createDocument>>;
export const useCreateDocumentKey = 'CreateDocument';
export const UseCreateDocumentKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateDocumentKey,
  ...(mutationKey ?? []),
];
export type DeleteDocumentMutationResult = Awaited<ReturnType<typeof deleteDocument>>;
export const useDeleteDocumentKey = 'DeleteDocument';
export const UseDeleteDocumentKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteDocumentKey,
  ...(mutationKey ?? []),
];
export type BatchUpdateDocumentMutationResult = Awaited<ReturnType<typeof batchUpdateDocument>>;
export const useBatchUpdateDocumentKey = 'BatchUpdateDocument';
export const UseBatchUpdateDocumentKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchUpdateDocumentKey,
  ...(mutationKey ?? []),
];
export type CreateProjectMutationResult = Awaited<ReturnType<typeof createProject>>;
export const useCreateProjectKey = 'CreateProject';
export const UseCreateProjectKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateProjectKey,
  ...(mutationKey ?? []),
];
export type UpdateProjectMutationResult = Awaited<ReturnType<typeof updateProject>>;
export const useUpdateProjectKey = 'UpdateProject';
export const UseUpdateProjectKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateProjectKey,
  ...(mutationKey ?? []),
];
export type UpdateProjectItemsMutationResult = Awaited<ReturnType<typeof updateProjectItems>>;
export const useUpdateProjectItemsKey = 'UpdateProjectItems';
export const UseUpdateProjectItemsKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateProjectItemsKey,
  ...(mutationKey ?? []),
];
export type DeleteProjectMutationResult = Awaited<ReturnType<typeof deleteProject>>;
export const useDeleteProjectKey = 'DeleteProject';
export const UseDeleteProjectKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteProjectKey,
  ...(mutationKey ?? []),
];
export type DeleteProjectItemsMutationResult = Awaited<ReturnType<typeof deleteProjectItems>>;
export const useDeleteProjectItemsKey = 'DeleteProjectItems';
export const UseDeleteProjectItemsKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteProjectItemsKey,
  ...(mutationKey ?? []),
];
export type CreateCodeArtifactMutationResult = Awaited<ReturnType<typeof createCodeArtifact>>;
export const useCreateCodeArtifactKey = 'CreateCodeArtifact';
export const UseCreateCodeArtifactKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateCodeArtifactKey,
  ...(mutationKey ?? []),
];
export type UpdateCodeArtifactMutationResult = Awaited<ReturnType<typeof updateCodeArtifact>>;
export const useUpdateCodeArtifactKey = 'UpdateCodeArtifact';
export const UseUpdateCodeArtifactKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateCodeArtifactKey,
  ...(mutationKey ?? []),
];
export type CreateShareMutationResult = Awaited<ReturnType<typeof createShare>>;
export const useCreateShareKey = 'CreateShare';
export const UseCreateShareKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateShareKey,
  ...(mutationKey ?? []),
];
export type DeleteShareMutationResult = Awaited<ReturnType<typeof deleteShare>>;
export const useDeleteShareKey = 'DeleteShare';
export const UseDeleteShareKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteShareKey,
  ...(mutationKey ?? []),
];
export type DuplicateShareMutationResult = Awaited<ReturnType<typeof duplicateShare>>;
export const useDuplicateShareKey = 'DuplicateShare';
export const UseDuplicateShareKeyFn = (mutationKey?: Array<unknown>) => [
  useDuplicateShareKey,
  ...(mutationKey ?? []),
];
export type CreateLabelClassMutationResult = Awaited<ReturnType<typeof createLabelClass>>;
export const useCreateLabelClassKey = 'CreateLabelClass';
export const UseCreateLabelClassKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateLabelClassKey,
  ...(mutationKey ?? []),
];
export type UpdateLabelClassMutationResult = Awaited<ReturnType<typeof updateLabelClass>>;
export const useUpdateLabelClassKey = 'UpdateLabelClass';
export const UseUpdateLabelClassKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateLabelClassKey,
  ...(mutationKey ?? []),
];
export type DeleteLabelClassMutationResult = Awaited<ReturnType<typeof deleteLabelClass>>;
export const useDeleteLabelClassKey = 'DeleteLabelClass';
export const UseDeleteLabelClassKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteLabelClassKey,
  ...(mutationKey ?? []),
];
export type CreateLabelInstanceMutationResult = Awaited<ReturnType<typeof createLabelInstance>>;
export const useCreateLabelInstanceKey = 'CreateLabelInstance';
export const UseCreateLabelInstanceKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateLabelInstanceKey,
  ...(mutationKey ?? []),
];
export type UpdateLabelInstanceMutationResult = Awaited<ReturnType<typeof updateLabelInstance>>;
export const useUpdateLabelInstanceKey = 'UpdateLabelInstance';
export const UseUpdateLabelInstanceKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateLabelInstanceKey,
  ...(mutationKey ?? []),
];
export type DeleteLabelInstanceMutationResult = Awaited<ReturnType<typeof deleteLabelInstance>>;
export const useDeleteLabelInstanceKey = 'DeleteLabelInstance';
export const UseDeleteLabelInstanceKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteLabelInstanceKey,
  ...(mutationKey ?? []),
];
export type AbortActionMutationResult = Awaited<ReturnType<typeof abortAction>>;
export const useAbortActionKey = 'AbortAction';
export const UseAbortActionKeyFn = (mutationKey?: Array<unknown>) => [
  useAbortActionKey,
  ...(mutationKey ?? []),
];
export type InvokeSkillMutationResult = Awaited<ReturnType<typeof invokeSkill>>;
export const useInvokeSkillKey = 'InvokeSkill';
export const UseInvokeSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useInvokeSkillKey,
  ...(mutationKey ?? []),
];
export type StreamInvokeSkillMutationResult = Awaited<ReturnType<typeof streamInvokeSkill>>;
export const useStreamInvokeSkillKey = 'StreamInvokeSkill';
export const UseStreamInvokeSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useStreamInvokeSkillKey,
  ...(mutationKey ?? []),
];
export type CreateSkillInstanceMutationResult = Awaited<ReturnType<typeof createSkillInstance>>;
export const useCreateSkillInstanceKey = 'CreateSkillInstance';
export const UseCreateSkillInstanceKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateSkillInstanceKey,
  ...(mutationKey ?? []),
];
export type UpdateSkillInstanceMutationResult = Awaited<ReturnType<typeof updateSkillInstance>>;
export const useUpdateSkillInstanceKey = 'UpdateSkillInstance';
export const UseUpdateSkillInstanceKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateSkillInstanceKey,
  ...(mutationKey ?? []),
];
export type PinSkillInstanceMutationResult = Awaited<ReturnType<typeof pinSkillInstance>>;
export const usePinSkillInstanceKey = 'PinSkillInstance';
export const UsePinSkillInstanceKeyFn = (mutationKey?: Array<unknown>) => [
  usePinSkillInstanceKey,
  ...(mutationKey ?? []),
];
export type UnpinSkillInstanceMutationResult = Awaited<ReturnType<typeof unpinSkillInstance>>;
export const useUnpinSkillInstanceKey = 'UnpinSkillInstance';
export const UseUnpinSkillInstanceKeyFn = (mutationKey?: Array<unknown>) => [
  useUnpinSkillInstanceKey,
  ...(mutationKey ?? []),
];
export type DeleteSkillInstanceMutationResult = Awaited<ReturnType<typeof deleteSkillInstance>>;
export const useDeleteSkillInstanceKey = 'DeleteSkillInstance';
export const UseDeleteSkillInstanceKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteSkillInstanceKey,
  ...(mutationKey ?? []),
];
export type CreateSkillTriggerMutationResult = Awaited<ReturnType<typeof createSkillTrigger>>;
export const useCreateSkillTriggerKey = 'CreateSkillTrigger';
export const UseCreateSkillTriggerKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateSkillTriggerKey,
  ...(mutationKey ?? []),
];
export type UpdateSkillTriggerMutationResult = Awaited<ReturnType<typeof updateSkillTrigger>>;
export const useUpdateSkillTriggerKey = 'UpdateSkillTrigger';
export const UseUpdateSkillTriggerKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateSkillTriggerKey,
  ...(mutationKey ?? []),
];
export type DeleteSkillTriggerMutationResult = Awaited<ReturnType<typeof deleteSkillTrigger>>;
export const useDeleteSkillTriggerKey = 'DeleteSkillTrigger';
export const UseDeleteSkillTriggerKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteSkillTriggerKey,
  ...(mutationKey ?? []),
];
export type GenerateMediaMutationResult = Awaited<ReturnType<typeof generateMedia>>;
export const useGenerateMediaKey = 'GenerateMedia';
export const UseGenerateMediaKeyFn = (mutationKey?: Array<unknown>) => [
  useGenerateMediaKey,
  ...(mutationKey ?? []),
];
export type CreatePilotSessionMutationResult = Awaited<ReturnType<typeof createPilotSession>>;
export const useCreatePilotSessionKey = 'CreatePilotSession';
export const UseCreatePilotSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useCreatePilotSessionKey,
  ...(mutationKey ?? []),
];
export type UpdatePilotSessionMutationResult = Awaited<ReturnType<typeof updatePilotSession>>;
export const useUpdatePilotSessionKey = 'UpdatePilotSession';
export const UseUpdatePilotSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdatePilotSessionKey,
  ...(mutationKey ?? []),
];
export type RecoverPilotSessionMutationResult = Awaited<ReturnType<typeof recoverPilotSession>>;
export const useRecoverPilotSessionKey = 'RecoverPilotSession';
export const UseRecoverPilotSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useRecoverPilotSessionKey,
  ...(mutationKey ?? []),
];
export type DeleteCopilotSessionMutationResult = Awaited<ReturnType<typeof deleteCopilotSession>>;
export const useDeleteCopilotSessionKey = 'DeleteCopilotSession';
export const UseDeleteCopilotSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteCopilotSessionKey,
  ...(mutationKey ?? []),
];
export type MaterializeCopilotSessionMutationResult = Awaited<
  ReturnType<typeof materializeCopilotSession>
>;
export const useMaterializeCopilotSessionKey = 'MaterializeCopilotSession';
export const UseMaterializeCopilotSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useMaterializeCopilotSessionKey,
  ...(mutationKey ?? []),
];
export type RestartWorkflowNodeMutationResult = Awaited<ReturnType<typeof restartWorkflowNode>>;
export const useRestartWorkflowNodeKey = 'RestartWorkflowNode';
export const UseRestartWorkflowNodeKeyFn = (mutationKey?: Array<unknown>) => [
  useRestartWorkflowNodeKey,
  ...(mutationKey ?? []),
];
export type StopPublishTaskMutationResult = Awaited<ReturnType<typeof stopPublishTask>>;
export const useStopPublishTaskKey = 'StopPublishTask';
export const UseStopPublishTaskKeyFn = (mutationKey?: Array<unknown>) => [
  useStopPublishTaskKey,
  ...(mutationKey ?? []),
];
export type InitializeWorkflowMutationResult = Awaited<ReturnType<typeof initializeWorkflow>>;
export const useInitializeWorkflowKey = 'InitializeWorkflow';
export const UseInitializeWorkflowKeyFn = (mutationKey?: Array<unknown>) => [
  useInitializeWorkflowKey,
  ...(mutationKey ?? []),
];
export type AbortWorkflowMutationResult = Awaited<ReturnType<typeof abortWorkflow>>;
export const useAbortWorkflowKey = 'AbortWorkflow';
export const UseAbortWorkflowKeyFn = (mutationKey?: Array<unknown>) => [
  useAbortWorkflowKey,
  ...(mutationKey ?? []),
];
export type CreateWorkflowAppMutationResult = Awaited<ReturnType<typeof createWorkflowApp>>;
export const useCreateWorkflowAppKey = 'CreateWorkflowApp';
export const UseCreateWorkflowAppKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateWorkflowAppKey,
  ...(mutationKey ?? []),
];
export type DeleteWorkflowAppMutationResult = Awaited<ReturnType<typeof deleteWorkflowApp>>;
export const useDeleteWorkflowAppKey = 'DeleteWorkflowApp';
export const UseDeleteWorkflowAppKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteWorkflowAppKey,
  ...(mutationKey ?? []),
];
export type ExecuteWorkflowAppMutationResult = Awaited<ReturnType<typeof executeWorkflowApp>>;
export const useExecuteWorkflowAppKey = 'ExecuteWorkflowApp';
export const UseExecuteWorkflowAppKeyFn = (mutationKey?: Array<unknown>) => [
  useExecuteWorkflowAppKey,
  ...(mutationKey ?? []),
];
export type CreateScheduleMutationResult = Awaited<ReturnType<typeof createSchedule>>;
export const useCreateScheduleKey = 'CreateSchedule';
export const UseCreateScheduleKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateScheduleKey,
  ...(mutationKey ?? []),
];
export type UpdateScheduleMutationResult = Awaited<ReturnType<typeof updateSchedule>>;
export const useUpdateScheduleKey = 'UpdateSchedule';
export const UseUpdateScheduleKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateScheduleKey,
  ...(mutationKey ?? []),
];
export type DeleteScheduleMutationResult = Awaited<ReturnType<typeof deleteSchedule>>;
export const useDeleteScheduleKey = 'DeleteSchedule';
export const UseDeleteScheduleKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteScheduleKey,
  ...(mutationKey ?? []),
];
export type ListSchedulesMutationResult = Awaited<ReturnType<typeof listSchedules>>;
export const useListSchedulesKey = 'ListSchedules';
export const UseListSchedulesKeyFn = (mutationKey?: Array<unknown>) => [
  useListSchedulesKey,
  ...(mutationKey ?? []),
];
export type GetScheduleDetailMutationResult = Awaited<ReturnType<typeof getScheduleDetail>>;
export const useGetScheduleDetailKey = 'GetScheduleDetail';
export const UseGetScheduleDetailKeyFn = (mutationKey?: Array<unknown>) => [
  useGetScheduleDetailKey,
  ...(mutationKey ?? []),
];
export type GetScheduleRecordsMutationResult = Awaited<ReturnType<typeof getScheduleRecords>>;
export const useGetScheduleRecordsKey = 'GetScheduleRecords';
export const UseGetScheduleRecordsKeyFn = (mutationKey?: Array<unknown>) => [
  useGetScheduleRecordsKey,
  ...(mutationKey ?? []),
];
export type ListAllScheduleRecordsMutationResult = Awaited<
  ReturnType<typeof listAllScheduleRecords>
>;
export const useListAllScheduleRecordsKey = 'ListAllScheduleRecords';
export const UseListAllScheduleRecordsKeyFn = (mutationKey?: Array<unknown>) => [
  useListAllScheduleRecordsKey,
  ...(mutationKey ?? []),
];
export type GetAvailableToolsMutationResult = Awaited<ReturnType<typeof getAvailableTools>>;
export const useGetAvailableToolsKey = 'GetAvailableTools';
export const UseGetAvailableToolsKeyFn = (mutationKey?: Array<unknown>) => [
  useGetAvailableToolsKey,
  ...(mutationKey ?? []),
];
export type GetScheduleRecordDetailMutationResult = Awaited<
  ReturnType<typeof getScheduleRecordDetail>
>;
export const useGetScheduleRecordDetailKey = 'GetScheduleRecordDetail';
export const UseGetScheduleRecordDetailKeyFn = (mutationKey?: Array<unknown>) => [
  useGetScheduleRecordDetailKey,
  ...(mutationKey ?? []),
];
export type GetRecordSnapshotMutationResult = Awaited<ReturnType<typeof getRecordSnapshot>>;
export const useGetRecordSnapshotKey = 'GetRecordSnapshot';
export const UseGetRecordSnapshotKeyFn = (mutationKey?: Array<unknown>) => [
  useGetRecordSnapshotKey,
  ...(mutationKey ?? []),
];
export type TriggerScheduleManuallyMutationResult = Awaited<
  ReturnType<typeof triggerScheduleManually>
>;
export const useTriggerScheduleManuallyKey = 'TriggerScheduleManually';
export const UseTriggerScheduleManuallyKeyFn = (mutationKey?: Array<unknown>) => [
  useTriggerScheduleManuallyKey,
  ...(mutationKey ?? []),
];
export type RetryScheduleRecordMutationResult = Awaited<ReturnType<typeof retryScheduleRecord>>;
export const useRetryScheduleRecordKey = 'RetryScheduleRecord';
export const UseRetryScheduleRecordKeyFn = (mutationKey?: Array<unknown>) => [
  useRetryScheduleRecordKey,
  ...(mutationKey ?? []),
];
export type CreateCliApiKeyMutationResult = Awaited<ReturnType<typeof createCliApiKey>>;
export const useCreateCliApiKeyKey = 'CreateCliApiKey';
export const UseCreateCliApiKeyKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateCliApiKeyKey,
  ...(mutationKey ?? []),
];
export type UpdateOpenapiConfigMutationResult = Awaited<ReturnType<typeof updateOpenapiConfig>>;
export const useUpdateOpenapiConfigKey = 'UpdateOpenapiConfig';
export const UseUpdateOpenapiConfigKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateOpenapiConfigKey,
  ...(mutationKey ?? []),
];
export type UploadOpenapiFilesMutationResult = Awaited<ReturnType<typeof uploadOpenapiFiles>>;
export const useUploadOpenapiFilesKey = 'UploadOpenapiFiles';
export const UseUploadOpenapiFilesKeyFn = (mutationKey?: Array<unknown>) => [
  useUploadOpenapiFilesKey,
  ...(mutationKey ?? []),
];
export type RunWorkflowViaApiMutationResult = Awaited<ReturnType<typeof runWorkflowViaApi>>;
export const useRunWorkflowViaApiKey = 'RunWorkflowViaApi';
export const UseRunWorkflowViaApiKeyFn = (mutationKey?: Array<unknown>) => [
  useRunWorkflowViaApiKey,
  ...(mutationKey ?? []),
];
export type GenerateWorkflowViaCopilotMutationResult = Awaited<
  ReturnType<typeof generateWorkflowViaCopilot>
>;
export const useGenerateWorkflowViaCopilotKey = 'GenerateWorkflowViaCopilot';
export const UseGenerateWorkflowViaCopilotKeyFn = (mutationKey?: Array<unknown>) => [
  useGenerateWorkflowViaCopilotKey,
  ...(mutationKey ?? []),
];
export type AbortWorkflowViaApiMutationResult = Awaited<ReturnType<typeof abortWorkflowViaApi>>;
export const useAbortWorkflowViaApiKey = 'AbortWorkflowViaApi';
export const UseAbortWorkflowViaApiKeyFn = (mutationKey?: Array<unknown>) => [
  useAbortWorkflowViaApiKey,
  ...(mutationKey ?? []),
];
export type SubmitFormMutationResult = Awaited<ReturnType<typeof submitForm>>;
export const useSubmitFormKey = 'SubmitForm';
export const UseSubmitFormKeyFn = (mutationKey?: Array<unknown>) => [
  useSubmitFormKey,
  ...(mutationKey ?? []),
];
export type ActivateInvitationCodeMutationResult = Awaited<
  ReturnType<typeof activateInvitationCode>
>;
export const useActivateInvitationCodeKey = 'ActivateInvitationCode';
export const UseActivateInvitationCodeKeyFn = (mutationKey?: Array<unknown>) => [
  useActivateInvitationCodeKey,
  ...(mutationKey ?? []),
];
export type CreateCheckoutSessionMutationResult = Awaited<ReturnType<typeof createCheckoutSession>>;
export const useCreateCheckoutSessionKey = 'CreateCheckoutSession';
export const UseCreateCheckoutSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateCheckoutSessionKey,
  ...(mutationKey ?? []),
];
export type CreateCreditPackCheckoutSessionMutationResult = Awaited<
  ReturnType<typeof createCreditPackCheckoutSession>
>;
export const useCreateCreditPackCheckoutSessionKey = 'CreateCreditPackCheckoutSession';
export const UseCreateCreditPackCheckoutSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateCreditPackCheckoutSessionKey,
  ...(mutationKey ?? []),
];
export type CreatePortalSessionMutationResult = Awaited<ReturnType<typeof createPortalSession>>;
export const useCreatePortalSessionKey = 'CreatePortalSession';
export const UseCreatePortalSessionKeyFn = (mutationKey?: Array<unknown>) => [
  useCreatePortalSessionKey,
  ...(mutationKey ?? []),
];
export type CreatePayOrderMutationResult = Awaited<ReturnType<typeof createPayOrder>>;
export const useCreatePayOrderKey = 'CreatePayOrder';
export const UseCreatePayOrderKeyFn = (mutationKey?: Array<unknown>) => [
  useCreatePayOrderKey,
  ...(mutationKey ?? []),
];
export type SearchMutationResult = Awaited<ReturnType<typeof search>>;
export const useSearchKey = 'Search';
export const UseSearchKeyFn = (mutationKey?: Array<unknown>) => [
  useSearchKey,
  ...(mutationKey ?? []),
];
export type MultiLingualWebSearchMutationResult = Awaited<ReturnType<typeof multiLingualWebSearch>>;
export const useMultiLingualWebSearchKey = 'MultiLingualWebSearch';
export const UseMultiLingualWebSearchKeyFn = (mutationKey?: Array<unknown>) => [
  useMultiLingualWebSearchKey,
  ...(mutationKey ?? []),
];
export type CreateManagedModelMutationResult = Awaited<ReturnType<typeof createManagedModel>>;
export const useCreateManagedModelKey = 'CreateManagedModel';
export const UseCreateManagedModelKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateManagedModelKey,
  ...(mutationKey ?? []),
];
export type UpdateManagedModelMutationResult = Awaited<ReturnType<typeof updateManagedModel>>;
export const useUpdateManagedModelKey = 'UpdateManagedModel';
export const UseUpdateManagedModelKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateManagedModelKey,
  ...(mutationKey ?? []),
];
export type UpdateManagedModelStatusMutationResult = Awaited<
  ReturnType<typeof updateManagedModelStatus>
>;
export const useUpdateManagedModelStatusKey = 'UpdateManagedModelStatus';
export const UseUpdateManagedModelStatusKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateManagedModelStatusKey,
  ...(mutationKey ?? []),
];
export type DeleteManagedModelMutationResult = Awaited<ReturnType<typeof deleteManagedModel>>;
export const useDeleteManagedModelKey = 'DeleteManagedModel';
export const UseDeleteManagedModelKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteManagedModelKey,
  ...(mutationKey ?? []),
];
export type CreateProviderMutationResult = Awaited<ReturnType<typeof createProvider>>;
export const useCreateProviderKey = 'CreateProvider';
export const UseCreateProviderKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateProviderKey,
  ...(mutationKey ?? []),
];
export type UpdateProviderMutationResult = Awaited<ReturnType<typeof updateProvider>>;
export const useUpdateProviderKey = 'UpdateProvider';
export const UseUpdateProviderKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateProviderKey,
  ...(mutationKey ?? []),
];
export type DeleteProviderMutationResult = Awaited<ReturnType<typeof deleteProvider>>;
export const useDeleteProviderKey = 'DeleteProvider';
export const UseDeleteProviderKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteProviderKey,
  ...(mutationKey ?? []),
];
export type TestProviderConnectionMutationResult = Awaited<
  ReturnType<typeof testProviderConnection>
>;
export const useTestProviderConnectionKey = 'TestProviderConnection';
export const UseTestProviderConnectionKeyFn = (mutationKey?: Array<unknown>) => [
  useTestProviderConnectionKey,
  ...(mutationKey ?? []),
];
export type CreateProviderItemMutationResult = Awaited<ReturnType<typeof createProviderItem>>;
export const useCreateProviderItemKey = 'CreateProviderItem';
export const UseCreateProviderItemKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateProviderItemKey,
  ...(mutationKey ?? []),
];
export type BatchCreateProviderItemsMutationResult = Awaited<
  ReturnType<typeof batchCreateProviderItems>
>;
export const useBatchCreateProviderItemsKey = 'BatchCreateProviderItems';
export const UseBatchCreateProviderItemsKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchCreateProviderItemsKey,
  ...(mutationKey ?? []),
];
export type UpdateProviderItemMutationResult = Awaited<ReturnType<typeof updateProviderItem>>;
export const useUpdateProviderItemKey = 'UpdateProviderItem';
export const UseUpdateProviderItemKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateProviderItemKey,
  ...(mutationKey ?? []),
];
export type BatchUpdateProviderItemsMutationResult = Awaited<
  ReturnType<typeof batchUpdateProviderItems>
>;
export const useBatchUpdateProviderItemsKey = 'BatchUpdateProviderItems';
export const UseBatchUpdateProviderItemsKeyFn = (mutationKey?: Array<unknown>) => [
  useBatchUpdateProviderItemsKey,
  ...(mutationKey ?? []),
];
export type DeleteProviderItemMutationResult = Awaited<ReturnType<typeof deleteProviderItem>>;
export const useDeleteProviderItemKey = 'DeleteProviderItem';
export const UseDeleteProviderItemKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteProviderItemKey,
  ...(mutationKey ?? []),
];
export type CreateToolsetMutationResult = Awaited<ReturnType<typeof createToolset>>;
export const useCreateToolsetKey = 'CreateToolset';
export const UseCreateToolsetKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateToolsetKey,
  ...(mutationKey ?? []),
];
export type UpdateToolsetMutationResult = Awaited<ReturnType<typeof updateToolset>>;
export const useUpdateToolsetKey = 'UpdateToolset';
export const UseUpdateToolsetKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateToolsetKey,
  ...(mutationKey ?? []),
];
export type DeleteToolsetMutationResult = Awaited<ReturnType<typeof deleteToolset>>;
export const useDeleteToolsetKey = 'DeleteToolset';
export const UseDeleteToolsetKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteToolsetKey,
  ...(mutationKey ?? []),
];
export type ExecuteToolMutationResult = Awaited<ReturnType<typeof executeTool>>;
export const useExecuteToolKey = 'ExecuteTool';
export const UseExecuteToolKeyFn = (mutationKey?: Array<unknown>) => [
  useExecuteToolKey,
  ...(mutationKey ?? []),
];
export type AuthorizeComposioConnectionMutationResult = Awaited<
  ReturnType<typeof authorizeComposioConnection>
>;
export const useAuthorizeComposioConnectionKey = 'AuthorizeComposioConnection';
export const UseAuthorizeComposioConnectionKeyFn = (mutationKey?: Array<unknown>) => [
  useAuthorizeComposioConnectionKey,
  ...(mutationKey ?? []),
];
export type RevokeComposioConnectionMutationResult = Awaited<
  ReturnType<typeof revokeComposioConnection>
>;
export const useRevokeComposioConnectionKey = 'RevokeComposioConnection';
export const UseRevokeComposioConnectionKeyFn = (mutationKey?: Array<unknown>) => [
  useRevokeComposioConnectionKey,
  ...(mutationKey ?? []),
];
export type ScrapeMutationResult = Awaited<ReturnType<typeof scrape>>;
export const useScrapeKey = 'Scrape';
export const UseScrapeKeyFn = (mutationKey?: Array<unknown>) => [
  useScrapeKey,
  ...(mutationKey ?? []),
];
export type UploadMutationResult = Awaited<ReturnType<typeof upload>>;
export const useUploadKey = 'Upload';
export const UseUploadKeyFn = (mutationKey?: Array<unknown>) => [
  useUploadKey,
  ...(mutationKey ?? []),
];
export type ConvertMutationResult = Awaited<ReturnType<typeof convert>>;
export const useConvertKey = 'Convert';
export const UseConvertKeyFn = (mutationKey?: Array<unknown>) => [
  useConvertKey,
  ...(mutationKey ?? []),
];
export type ValidateVoucherMutationResult = Awaited<ReturnType<typeof validateVoucher>>;
export const useValidateVoucherKey = 'ValidateVoucher';
export const UseValidateVoucherKeyFn = (mutationKey?: Array<unknown>) => [
  useValidateVoucherKey,
  ...(mutationKey ?? []),
];
export type CreateVoucherInvitationMutationResult = Awaited<
  ReturnType<typeof createVoucherInvitation>
>;
export const useCreateVoucherInvitationKey = 'CreateVoucherInvitation';
export const UseCreateVoucherInvitationKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateVoucherInvitationKey,
  ...(mutationKey ?? []),
];
export type ClaimVoucherInvitationMutationResult = Awaited<
  ReturnType<typeof claimVoucherInvitation>
>;
export const useClaimVoucherInvitationKey = 'ClaimVoucherInvitation';
export const UseClaimVoucherInvitationKeyFn = (mutationKey?: Array<unknown>) => [
  useClaimVoucherInvitationKey,
  ...(mutationKey ?? []),
];
export type CreatePromptSkillMutationResult = Awaited<ReturnType<typeof createPromptSkill>>;
export const useCreatePromptSkillKey = 'CreatePromptSkill';
export const UseCreatePromptSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useCreatePromptSkillKey,
  ...(mutationKey ?? []),
];
export type UpdatePromptSkillMutationResult = Awaited<ReturnType<typeof updatePromptSkill>>;
export const useUpdatePromptSkillKey = 'UpdatePromptSkill';
export const UseUpdatePromptSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdatePromptSkillKey,
  ...(mutationKey ?? []),
];
export type TogglePromptSkillMutationResult = Awaited<ReturnType<typeof togglePromptSkill>>;
export const useTogglePromptSkillKey = 'TogglePromptSkill';
export const UseTogglePromptSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useTogglePromptSkillKey,
  ...(mutationKey ?? []),
];
export type DeletePromptSkillMutationResult = Awaited<ReturnType<typeof deletePromptSkill>>;
export const useDeletePromptSkillKey = 'DeletePromptSkill';
export const UseDeletePromptSkillKeyFn = (mutationKey?: Array<unknown>) => [
  useDeletePromptSkillKey,
  ...(mutationKey ?? []),
];
export type SaveVideoEditProjectSnapshotMutationResult = Awaited<
  ReturnType<typeof saveVideoEditProjectSnapshot>
>;
export const useSaveVideoEditProjectSnapshotKey = 'SaveVideoEditProjectSnapshot';
export const UseSaveVideoEditProjectSnapshotKeyFn = (mutationKey?: Array<unknown>) => [
  useSaveVideoEditProjectSnapshotKey,
  ...(mutationKey ?? []),
];
export type UpdatePageMutationResult = Awaited<ReturnType<typeof updatePage>>;
export const useUpdatePageKey = 'UpdatePage';
export const UseUpdatePageKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdatePageKey,
  ...(mutationKey ?? []),
];
export type UpdateSettingsMutationResult = Awaited<ReturnType<typeof updateSettings>>;
export const useUpdateSettingsKey = 'UpdateSettings';
export const UseUpdateSettingsKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateSettingsKey,
  ...(mutationKey ?? []),
];
export type UpdateProductionStudioClientPackStatusMutationResult = Awaited<
  ReturnType<typeof updateProductionStudioClientPackStatus>
>;
export const useUpdateProductionStudioClientPackStatusKey =
  'UpdateProductionStudioClientPackStatus';
export const UseUpdateProductionStudioClientPackStatusKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateProductionStudioClientPackStatusKey,
  ...(mutationKey ?? []),
];
export type UpdateProductionStudioClientPackAssetMutationResult = Awaited<
  ReturnType<typeof updateProductionStudioClientPackAsset>
>;
export const useUpdateProductionStudioClientPackAssetKey = 'UpdateProductionStudioClientPackAsset';
export const UseUpdateProductionStudioClientPackAssetKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateProductionStudioClientPackAssetKey,
  ...(mutationKey ?? []),
];
export type UpdateProductionStudioBatchMutationResult = Awaited<
  ReturnType<typeof updateProductionStudioBatch>
>;
export const useUpdateProductionStudioBatchKey = 'UpdateProductionStudioBatch';
export const UseUpdateProductionStudioBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateProductionStudioBatchKey,
  ...(mutationKey ?? []),
];
export type UpdateMediaLibraryEntryMutationResult = Awaited<
  ReturnType<typeof updateMediaLibraryEntry>
>;
export const useUpdateMediaLibraryEntryKey = 'UpdateMediaLibraryEntry';
export const UseUpdateMediaLibraryEntryKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateMediaLibraryEntryKey,
  ...(mutationKey ?? []),
];
export type UpdateCliApiKeyMutationResult = Awaited<ReturnType<typeof updateCliApiKey>>;
export const useUpdateCliApiKeyKey = 'UpdateCliApiKey';
export const UseUpdateCliApiKeyKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateCliApiKeyKey,
  ...(mutationKey ?? []),
];
export type DeleteSocialAccountMutationResult = Awaited<ReturnType<typeof deleteSocialAccount>>;
export const useDeleteSocialAccountKey = 'DeleteSocialAccount';
export const UseDeleteSocialAccountKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteSocialAccountKey,
  ...(mutationKey ?? []),
];
export type DeleteSocialAccountCategoryMutationResult = Awaited<
  ReturnType<typeof deleteSocialAccountCategory>
>;
export const useDeleteSocialAccountCategoryKey = 'DeleteSocialAccountCategory';
export const UseDeleteSocialAccountCategoryKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteSocialAccountCategoryKey,
  ...(mutationKey ?? []),
];
export type UnbindSocialAccountFromCategoryMutationResult = Awaited<
  ReturnType<typeof unbindSocialAccountFromCategory>
>;
export const useUnbindSocialAccountFromCategoryKey = 'UnbindSocialAccountFromCategory';
export const UseUnbindSocialAccountFromCategoryKeyFn = (mutationKey?: Array<unknown>) => [
  useUnbindSocialAccountFromCategoryKey,
  ...(mutationKey ?? []),
];
export type DeleteProductionStudioBatchMutationResult = Awaited<
  ReturnType<typeof deleteProductionStudioBatch>
>;
export const useDeleteProductionStudioBatchKey = 'DeleteProductionStudioBatch';
export const UseDeleteProductionStudioBatchKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteProductionStudioBatchKey,
  ...(mutationKey ?? []),
];
export type DeleteProductionStudioScriptMutationResult = Awaited<
  ReturnType<typeof deleteProductionStudioScript>
>;
export const useDeleteProductionStudioScriptKey = 'DeleteProductionStudioScript';
export const UseDeleteProductionStudioScriptKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteProductionStudioScriptKey,
  ...(mutationKey ?? []),
];
export type DeletePageNodeMutationResult = Awaited<ReturnType<typeof deletePageNode>>;
export const useDeletePageNodeKey = 'DeletePageNode';
export const UseDeletePageNodeKeyFn = (mutationKey?: Array<unknown>) => [
  useDeletePageNodeKey,
  ...(mutationKey ?? []),
];
export type RevokeCliApiKeyMutationResult = Awaited<ReturnType<typeof revokeCliApiKey>>;
export const useRevokeCliApiKeyKey = 'RevokeCliApiKey';
export const UseRevokeCliApiKeyKeyFn = (mutationKey?: Array<unknown>) => [
  useRevokeCliApiKeyKey,
  ...(mutationKey ?? []),
];
